<template>
  <div class="task-official-box">
    <div class="box-shadow">
      <div class="nav-box">
        <span class="go-back" @click="handleCancel">返回列表</span>
        <span class="division"></span>
        <span class="title">{{ titleList[activityType] }}</span>
      </div>
      <div class="task-content">
        <div :class="activityType != 14 ? 'step1-box' : 'step1-box-long'">
          <div class="step-bar">
            <span class="serial" :style="{ background: globalBG }">1</span>
            <span class="division" :style="{ background: globalBG }"></span>
            <span class="name">筛选任务条件</span>
          </div>
          <el-form
            ref="formSearch"
            :model="formData"
            label-width="164px"
            style="width: 855px; display: inline-block"
          >
            <el-form-item label="任务名称:">
              <el-input
                style="width: 648px"
                v-model="formData.activityName"
                :disabled="isCatch"
                placeholder="请输入任务名称"
                size="small"
                maxlength="30"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="任务时间:">
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  :disabled="isCatch"
                  v-model="formData.activityStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :picker-options="startTimeOption"
                  @change="moneyPayTimeChange"
                ></el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formData.activityEndTime"
                  :disabled="isCatch"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px"
                  class="time2"
                  :picker-options="endTimeOption"
                  :clearable="false"
                  @change="moneyPayTimeChange"
                ></el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearTime"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
              <div class="tip-box-global" v-if="activityType == 14">
                <i class="el-icon-warning warning-icon"></i>
                <span
                  >因短信营销接口限制，只有当天可营销人数不低于2人时才会正常执行短信任务</span
                >
              </div>
            </el-form-item>
            <el-form-item label="发送时间:" v-if="activityType == 14">
              <!-- 新增的商品复购发送时间与自动化营销相似 -->
              <el-radio-group
                v-model="formData.warePeriodType"
                @change="wareType"
                :disabled="isCatch"
              >
                <el-radio :label="1">
                  <span style="padding: 0 16px 0 0">回购型</span>
                  <span>商品消耗完</span>
                  <el-select
                    v-model="formData.wareConsumeType"
                    @change="wareChange"
                    placeholder="请选择"
                    size="small"
                    style="width: 76px; margin: 0 6px"
                    :disabled="isCatch"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    size="small"
                    v-if="formData.wareConsumeType != 0"
                    style="width: 56px"
                    maxlength="10"
                    @blur="sendConditionTips"
                    @input="changeForceUpdate"
                    @keyup.native="limitInput($event)"
                    v-model="formData.sendConditionDay"
                    :disabled="isCatch"
                  ></el-input>
                  <span>天发送短信（订单完成后计算时间）。每天</span>
                  <el-time-picker
                    v-model="formData.sendTime"
                    :disabled="isCatch"
                    v-if="formData.warePeriodType == 1"
                    format="HH:mm:ss"
                    value-format="HH:mm:ss"
                    :picker-options="sendTimeDate"
                    placeholder="选择时间"
                    class="day-padding"
                    style="margin-left: 8px; width: 120px; margin-right: 10px"
                    @change="timeChange"
                  >
                  </el-time-picker>
                  <el-time-picker
                    :disabled="isCatch"
                    v-if="formData.warePeriodType == 2"
                    format="HH:mm:ss"
                    value-format="HH:mm:ss"
                    :picker-options="sendTimeDate"
                    placeholder="选择时间"
                    class="day-padding"
                    style="margin-left: 8px; width: 120px; margin-right: 10px"
                    @change="timeChange"
                  >
                  </el-time-picker>
                  <!-- <el-input
                    size="small"
                    style="width: 50px; margin: 0 6px"
                    maxlength="10"
                    v-if="formData.warePeriodType == 1"
                    @blur="sendConditionTips"
                    @input="changeForceUpdate"
                    @keyup.native="limitInput($event)"
                    v-model="formData.sendConditionHour"
                    :disabled="isCatch"
                  ></el-input>
                  <el-input
                    size="small"
                    style="width: 50px; margin: 0 6px"
                    maxlength="10"
                    v-if="formData.warePeriodType == 2"
                    :disabled="isCatch"
                  ></el-input> -->
                  <span>时发送短信</span>
                </el-radio>

                <br />
                <el-radio :label="2">
                  <span style="padding: 0 16px 0 0">推荐型</span>
                  <span
                    >到商品推荐周期立即发送短信（订单完成后计算时间）。每天</span
                  >
                  <el-time-picker
                    v-model="formData.sendTime"
                    :disabled="isCatch"
                    v-if="formData.warePeriodType == 2"
                    format="HH:mm:ss"
                    value-format="HH:mm:ss"
                    :picker-options="sendTimeDate"
                    placeholder="选择时间"
                    class="day-padding"
                    style="margin-left: 8px; width: 120px; margin-right: 10px"
                    @change="timeChange"
                  >
                  </el-time-picker>
                  <el-time-picker
                    :disabled="isCatch"
                    v-if="formData.warePeriodType == 1"
                    format="HH:mm:ss"
                    value-format="HH:mm:ss"
                    :picker-options="sendTimeDate"
                    placeholder="选择时间"
                    class="day-padding"
                    style="margin-left: 8px; width: 120px; margin-right: 10px"
                    @change="timeChange"
                  >
                  </el-time-picker>
                  <!-- <el-input
                    size="small"
                    style="width: 50px; margin: 0 6px"
                    maxlength="10"
                    @blur="sendConditionTips"
                    @input="changeForceUpdate"
                    @keyup.native="limitInput($event)"
                    v-model="formData.sendConditionHour"
                    v-if="formData.warePeriodType == 2"
                    :disabled="isCatch"
                  ></el-input>
                  <el-input
                    size="small"
                    style="width: 50px; margin: 0 6px"
                    maxlength="10"
                    v-if="formData.warePeriodType == 1"
                    @input="changeForceUpdate"
                    @keyup.native="limitInput($event)"
                    :disabled="isCatch"
                  ></el-input> -->
                  <span>时发送短信</span>
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="发送时间:" v-else>
              <span v-if="activityType == '2' || activityType == '3'"
                >距离客户最后一次成交</span
              >
              <el-input
                v-if="activityType == '2' || activityType == '3'"
                :disabled="isCatch"
                v-model="formData.lastBuyAfterDays"
                oninput="value=value.replace(/^\.+|[^\d]/g,'')"
                style="width: 80px; padding: 0 8px"
              >
              </el-input>
              <span v-if="activityType == '3'">~</span>
              <el-input
                v-if="activityType == '3'"
                :disabled="isCatch"
                v-model="formData.lastBuyAfterEndDays"
                oninput="value=value.replace(/^\.+|[^\d]/g,'')"
                style="width: 80px; padding: 0 8px"
              >
              </el-input>
              <span
                v-if="activityType == '2' || activityType == '3'"
                style="margin-right: 10px"
                >天时自动发送短信</span
              >
              <!-- 会员日营销 -->
              <template v-if="activityType == '16'">
                <div style="display: inline-block">
                  <dropdown-date-multiple-selection
                    :days="formData.cycleDayMonthly"
                    @changeDays="changeDays"
                    :limit="isCatch"
                  ></dropdown-date-multiple-selection>
                </div>
              </template>
              <span v-if="activityType != '16'">每日</span>
              <el-time-picker
                v-model="formData.sendTime"
                :disabled="isCatch"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
                :picker-options="sendTimeDate"
                placeholder="选择时间"
                class="day-padding"
                style="margin-left: 8px; width: 136px; margin-right: 10px"
                @change="timeChange"
              ></el-time-picker>

              <span>点发送</span>
              <span class="send-tip"
                >注意：京东人群数据推送时间不固定，建议发送时间设置为下午；</span
              >
              <div v-if="activityType == 16" style="margin-left: -20px">
                <i class="el-icon-warning warning-icon"></i>
                <span style="margin-left: 5px"
                  >若当月无选中的日期，则不发送短信</span
                >
              </div>
            </el-form-item>

            <!-- <div> -->
              <!-- <div style="width:920px;line-height:22px;color:red;">
                <div>注意：</div>
                <div>
                  （1）双11大促期间短信发送时间：10月14日、10月15日、10月23日、10月24日、10月31日、11月1日、11月10日、11月11日 9:00-24:00；10月16日-10月22日、10月25日-10月30日、11月2日-11月9日 9:00-21:00；11月12日起恢复正常，即   09:00-20:00（*包含普通短信、富信、卡片短信）
                </div>
                <div>
                  （2）10月14日-11月11日大促期频控规则：同一店铺 2 天内给同一手机号发送商家营销短信的条数不超过 1条;每个手机号每 1天只能收到 5 条商家营销短信,每 2天只能收到 10 条商家营销短信（*商家营销短信包括普通短信、富信、卡片短信）
                </div>
              </div> -->
            <!-- </div> -->
            <!-- <festivals
              style="margin-top: -16px; margin-bottom: 4px; margin-left: 95px"
            ></festivals> -->
            <el-form-item label="发送对象:" v-if="activityType != 14">
              <div>
                <span v-if="activityType == '1'"
                  >人数为昨日新增的,首次成交的客户人数</span
                >
                <span v-if="activityType == '2'">
                  <el-radio-group
                    v-model="formData.sendObject"
                    :disabled="isCatch"
                  >
                    <el-radio :label="0">全部成交客户</el-radio>
                    <el-radio :label="1">全部成交会员</el-radio>
                  </el-radio-group>
                </span>
                <span v-if="activityType == '3'"> 全部成交客户 </span>
                <span v-if="activityType == '11'">全部客户</span>
                <span v-if="activityType == '9'">高价值入会客户</span>
                <span v-if="activityType == '13'">大促高转化客户</span>
                <span v-if="activityType == '12'">预售偏好客户</span>
                <span v-if="activityType == '8'">有新品购买偏好的客户</span>
                <span v-if="activityType == '4'">
                  近
                  <el-input
                    :disabled="isCatch"
                    v-model.number="formData.userActDayStart"
                    style="width: 90px"
                  ></el-input>
                  -
                  <el-input
                    :disabled="isCatch"
                    v-model.number="formData.userActDayEnd"
                    style="width: 90px"
                  ></el-input>
                  天有加购或者关注但无成交的客户
                </span>
                <span v-if="activityType == '10'">
                  针对积分余额剩余
                  <el-input
                    :disabled="isCatch"
                    v-model.number="formData.userActNumStart"
                    style="width: 90px"
                  ></el-input>
                  -
                  <el-input
                    :disabled="isCatch"
                    v-model.number="formData.userActNumEnd"
                    style="width: 90px"
                  ></el-input>
                  的用户
                </span>
                <span
                  v-if="
                    activityType == '5' ||
                    activityType == '6' ||
                    activityType == '7'
                  "
                >
                  {{ SendObjectText1[activityType] }}
                  <el-input
                    :disabled="isCatch"
                    v-model.number="formData.userActDayStart"
                    style="width: 90px"
                  ></el-input>
                  <template v-if="activityType == '5'">
                    天，且近30天在店铺浏览次数大于等于
                    <el-input
                      :disabled="isCatch"
                      v-model="formData.last30daysPvMore"
                      @input="formData.last30daysPvMore = inputLast($event)"
                      style="width: 90px"
                    ></el-input>
                  </template>
                  {{ SendObjectText2[activityType] }}
                  <!-- <el-tooltip v-if="activityType == '5'" class="item" effect="dark"
                    content="注意：这里开卡满几天不是指满足条件的历史所有用户，而是指那一天的开卡用户。比如 今天是6月18日，设置的满3天，则指的是6月15日开卡入会但是至今从未购买过的用户"
                    placement="right">
                    <img src="@/assets/images/ask.png" alt="" style="margin-bottom: -2px; cursor: pointer" />
                  </el-tooltip> -->
                </span>
                <el-radio-group
                  v-model="formData.isOneDayBirth"
                  @change="formData.userActDayStart = ''"
                  v-if="activityType == '15'"
                >
                  <el-radio :disabled="isCatch" :label="true"
                    >当天生日的会员</el-radio
                  >

                  <el-radio :disabled="isCatch" :label="false">
                    距离生日前
                    <el-input
                      :disabled="formData.isOneDayBirth || isCatch"
                      oninput="if(this.value=='0'){this.value='';}else{this.value=this.value.replace(/[^0-9]/g,'')}"
                      style="width: 68px; margin-right: 8px"
                      v-model="formData.userActDayStart"
                    >
                    </el-input
                    >天的会员
                  </el-radio>
                </el-radio-group>
                <template v-if="activityType == '16'">
                  <div>
                    <span>会员开卡时间：</span>
                    <div style="display: inline-block">
                      <el-select
                        style="width: 100px; margin-right: 20px"
                        v-model="formData.userActDateSelectType"
                        @change="handleMembershipOpeningTimeType"
                        :disabled="isCatch"
                      >
                        <el-option
                          v-for="(item, index) in areaSelectTime"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- 区间时间 -->
                      <div
                        class="my_select_time"
                        v-if="formData.userActDateSelectType === 0"
                      >
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="formData.userActDateStart"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="membershipOpenMinTimeOption"
                          value-format="yyyy-MM-dd"
                          style="width: 120px"
                          class="time1"
                          :disabled="isCatch"
                          :clearable="false"
                        ></el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="formData.userActDateEnd"
                          :picker-options="membershipOpenMaxTimeOption"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          style="width: 135px"
                          class="time2"
                          :clearable="false"
                          :disabled="isCatch"
                        ></el-date-picker>
                        <i
                          class="el-icon-circle-close date_icon1"
                          @click="clearmembershipTime"
                        ></i>
                        <img
                          src="@/assets/images/select_date.svg"
                          alt
                          class="date_icon2"
                        />
                      </div>
                      <!-- 小于时间 -->
                      <el-date-picker
                        v-if="formData.userActDateSelectType === 2"
                        prefix-icon="no_icon"
                        v-model="formData.userActDateEnd"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                        :disabled="isCatch"
                      ></el-date-picker>
                      <!-- 大于时间 -->
                      <el-date-picker
                        v-if="formData.userActDateSelectType == 1"
                        prefix-icon="no_icon"
                        v-model="formData.userActDateStart"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                        :disabled="isCatch"
                      ></el-date-picker>
                      <!-- 相对时间 -->
                      <span v-if="formData.userActDateSelectType == 3">
                        <el-input
                          @input="handleCount('relativeDayStart')"
                          placeholder="天"
                          v-model="formData.relativeDayStart"
                          style="width: 125px"
                          :disabled="isCatch"
                        ></el-input>
                        <span style="margin: 0 8px" class="to-text">至</span>
                        <el-input
                          @input="handleCount('relativeDayEnd')"
                          placeholder="天"
                          style="width: 125px"
                          v-model="formData.relativeDayEnd"
                          :disabled="isCatch"
                        ></el-input>
                      </span>
                    </div>
                    <!-- <span class="tip-text">时间为空则默认是历史所有时间</span> -->
                  </div>
                  <!-- 会员等级 -->
                  <div style="margin-top: 5px">
                    <span style="margin-right: 5px">会员等级：</span>
                    <el-checkbox-group
                      v-model="formData.memberLevel"
                      class="checked-box"
                      :disabled="isCatch"
                      @change="handlechackBox"
                    >
                      <el-checkbox
                        v-for="item in memberList"
                        :label="item.value"
                        :key="item.value"
                      >
                        <span>{{ item.label }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                    <span class="tip-text">不勾选则默认所有会员</span>
                  </div>
                  <!-- 会员积分 -->
                  <div style="margin-top: 5px">
                    <span>会员积分：</span>
                    <div style="display: inline-block">
                      <el-select
                        @change="handlePoint"
                        v-model="formData.memberPointsType"
                        style="margin-right: 5px; width: 100px"
                        :disabled="isCatch"
                      >
                        <el-option
                          v-for="(item, index) in areaSelect"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-input
                        v-if="formData.memberPointsType != -1"
                        placeholder="起"
                        v-model="formData.userActNumStart"
                        @input="handelInput('userActNumStart')"
                        style="width: 120px"
                        :disabled="isCatch"
                      ></el-input>
                      <span
                        v-if="formData.memberPointsType == 0"
                        class="to-text"
                        style="margin-left: 5px; margin-right: 5px"
                        >至</span
                      >
                      <el-input
                        v-if="formData.memberPointsType != 1"
                        placeholder="至"
                        v-model="formData.userActNumEnd"
                        @input="handelInput('userActNumEnd')"
                        style="width: 120px"
                        :disabled="isCatch"
                      ></el-input>
                    </div>

                    <!-- <span class="tip-text">不填写则默认是所有积分值会员</span> -->
                  </div>
                  <!-- 会员价值 -->
                  <div style="margin-left: -20px; margin-top: 5px">
                    <el-tooltip
                      placement="top"
                      width="200"
                      effect="light"
                      trigger="hover"
                      content="根据近一年的购物行为数据综合评价得出"
                    >
                      <i
                        class="el-icon-question"
                        :style="actIcon ? 'color: red' : ''"
                        @mouseover="actIcon = true"
                        @mouseleave="actIcon = false"
                      ></i>
                    </el-tooltip>
                    <span style="margin-left: 5px">会员价值：</span>
                    <el-checkbox-group
                      v-model="formData.userValue"
                      class="checked-box"
                      :disabled="isCatch"
                      @change="handlechackBox"
                    >
                      <el-checkbox
                        v-for="item in mebershipValueOption"
                        :label="item.value"
                        :key="item.value"
                      >
                        <span>{{ item.label }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                    <span class="tip-text">不勾选则默认所有会员</span>
                  </div>
                </template>
                <template v-if="activityType == '17'">
                  <div>
                    <span>京享值人群：</span>
                    <el-select
                      v-model="formData.jdGroupType"
                      placeholder="请选择"
                      :disabled="isCatch"
                      style="margin-right: 5px; width: 100px"
                      @change="handleJdGroupType"
                    >
                      <el-option
                        v-for="item in areaSelect"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      v-model="formData.jdGroupMin"
                      :disabled="isCatch"
                      placeholder="起"
                      style="width: 120px"
                      @input="handleCount('jdGroupMin')"
                      v-if="formData.jdGroupType != -1"
                    ></el-input>
                    <span
                      style="margin-left: 5px; margin-right: 5px"
                      v-if="formData.jdGroupType == 0"
                      >至</span
                    >
                    <el-input
                      v-model="formData.jdGroupMax"
                      :disabled="isCatch"
                      placeholder="至"
                      style="width: 120px"
                      @input="handleCount('jdGroupMax')"
                      v-if="formData.jdGroupType != 1"
                    ></el-input>
                  </div>
                  <div style="margin-top: 5px" class="jdDays">
                    <el-checkbox
                      v-model="formData.isjdDays"
                      :disabled="isCatch"
                      style="margin-right: 5px"
                      text-color="#fff"
                      @change="changeCheck"
                    >
                      <span>近</span>
                      <!-- TODO：限制1-90 -->
                      <el-input
                        v-model="formData.isShowDays"
                        :disabled="!formData.isjdDays || isCatch"
                        placeholder="请输入"
                        style="width: 100px; margin-left: 8px"
                        @input="handleInputByNinety('isShowDays')"
                      ></el-input>
                      <span>（1-90）天有加购或关注商品但未成交</span>
                    </el-checkbox>
                  </div>
                </template>
                <template v-if="activityType == '18'">
                  <div>京东plus会员</div>
                  <div style="margin-top: 5px">
                    <span style="margin-right: 5px">plus会员状态：</span>
                    <el-checkbox-group
                      v-model="formData.plusLevel"
                      :disabled="isCatch"
                      class="checked-box"
                      @change="handlechackBox"
                    >
                      <el-checkbox
                        v-for="(item, index) in plusOption"
                        :label="item.value"
                        :key="index"
                      >
                        <span>{{ item.label }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                    <span class="tip-text">不勾选则默认所有会员</span>
                  </div>
                  <div style="margin-top: 5px">
                    <span style="margin-right: 5px">会员等级：</span>
                    <el-checkbox-group
                      v-model="formData.level2"
                      :disabled="isCatch"
                      class="checked-box"
                      @change="handlechackBox"
                    >
                      <el-checkbox
                        v-for="item in levelOption"
                        :label="item.value"
                        :key="item.value"
                      >
                        <span>{{ item.label }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                    <span class="tip-text">不勾选则默认所有会员</span>
                  </div>
                </template>
                <template v-if="activityType == '19'">
                  <div>
                    储值卡用户
                    <span class="tip-text" style="width: 350px"
                      >注意：以下除了储值卡余额，其他查询数据范围是近一年</span
                    >
                  </div>
                  <div style="margin-top: 5px">
                    <div class="span-text">充值时间：</div>
                    <div style="display: inline-block">
                      <!-- <el-select @change="clearReChangeTime" v-model="formData.reChangeTimeType" style="width: 100px; margin-right: 5px">
                        <el-option v-for="(item, index) in areaSelectTime2" :key="index" :label="item.label" :value="item.value"></el-option>
                      </el-select> -->
                      <!-- 区间时间 -->
                      <div
                        class="my_select_time"
                      >
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="formData.reChangeMinTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="reChangeMinTimeOption"
                          value-format="yyyy-MM-dd"
                          style="width: 120px"
                          class="time1"
                          :clearable="false"
                          :disabled="isCatch"
                        ></el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker
                          prefix-icon="no_icon"
                          :default-value="new Date()"
                          v-model="formData.reChangeMaxTime"
                          :picker-options="reChangeMaxTimeOption"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          style="width: 135px"
                          class="time2"
                          :clearable="false"
                          :disabled="isCatch"
                        ></el-date-picker>
                        <i
                          class="el-icon-circle-close date_icon1"
                          @click="clearReChangeTime"
                        ></i>
                        <img
                          src="@/assets/images/select_date.svg"
                          alt
                          class="date_icon2"
                        />
                      </div>
                      <!-- 日期 -->
                      <!-- <el-date-picker
                        v-if="formData.reChangeTimeType == 4"
                        type="dates"
                        prefix-icon="no_icon"
                        class="datePicker"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        v-model="formData.dates"
                        placeholder="选择一个或多个日期"
                      >
                      </el-date-picker> -->
                    </div>
                  </div>
                  <div style="margin-top: 5px">
                    <div class="span-text">充值次数：</div>
                    <el-select
                      v-model="formData.rechargeTimeType"
                      placeholder="请选择"
                      style="margin-right: 5px; width: 100px"
                      @change="handlerechargeType"
                      :disabled="isCatch"
                    >
                      <el-option
                        v-for="item in areaSelect"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <!-- TODO：不能为空设置 -->
                    <el-input
                      v-model="formData.rechargeFirst"
                      placeholder="起"
                      style="width: 120px"
                      :min="0"
                      :disabled="isCatch"
                      @input="handleCount('rechargeFirst', true)"
                      v-if="formData.rechargeTimeType != -1"
                    ></el-input>
                    <span
                      style="margin-left: 5px; margin-right: 5px"
                      v-if="formData.rechargeTimeType == 0"
                      >至</span
                    >
                    <el-input
                      v-model="formData.rechargeEnd"
                      :disabled="isCatch"
                      placeholder="至"
                      style="width: 120px"
                      :min="0"
                      @input="handleCount('rechargeEnd', true)"
                      v-if="formData.rechargeTimeType != 1"
                    ></el-input>
                  </div>
                  <div style="margin-top: 5px">
                    <div class="span-text">充值金额：</div>
                    <el-select
                      v-model="formData.rechargeAmountType"
                      :disabled="isCatch"
                      placeholder="请选择"
                      style="margin-right: 5px; width: 100px"
                      @change="handlerechargeAmountType"
                    >
                      <el-option
                        v-for="item in areaSelect"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      v-model="formData.userActAmountStart"
                      :disabled="isCatch"
                      :min="0"
                      style="width: 120px"
                      v-if="formData.rechargeAmountType != -1"
                      @input="handleCount('userActAmountStart', true)"
                    ></el-input>
                    <span
                      style="margin-left: 5px; margin-right: 5px"
                      v-if="formData.rechargeAmountType == 0"
                      >至</span
                    >
                    <el-input
                      v-model="formData.userActAmountEnd"
                      :disabled="isCatch"
                      :min="0"
                      style="width: 120px"
                      v-if="formData.rechargeAmountType != 1"
                      @input="handleCount('userActAmountEnd', true)"
                    ></el-input>
                  </div>
                  <div style="margin-top: 5px">
                    <div class="span-text">储值卡余额：</div>
                    <el-select
                      v-model="formData.cardType"
                      :disabled="isCatch"
                      placeholder="请选择"
                      style="margin-right: 5px; width: 100px"
                      @change="handlereCardType"
                    >
                      <el-option
                        v-for="item in areaSelect"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      v-model="formData.userActAmountStart2"
                      :disabled="isCatch"
                      :min="0"
                      style="width: 120px"
                      v-if="formData.cardType != -1"
                      @input="handleCount('userActAmountStart2', true)"
                    ></el-input>
                    <span
                      style="margin-left: 5px; margin-right: 5px"
                      v-if="formData.cardType == 0"
                      >至</span
                    >
                    <el-input
                      v-model="formData.userActAmountEnd2"
                      :disabled="isCatch"
                      :min="0"
                      style="width: 120px"
                      v-if="formData.cardType != 1"
                      @input="handleCount('userActAmountEnd2', true)"
                    ></el-input>
                  </div>
                </template>
              </div>
              <div class="tip-box-global">
                <i class="el-icon-warning warning-icon"></i>
                <span
                  >因短信营销接口限制，只有当天可营销人数不低于2人时才会正常执行短信任务</span
                >
              </div>
            </el-form-item>
            <el-form-item label="发送人数:">
              <el-radio-group
                v-model="formData.isLimitSend"
                @change="handleLimitSend"
              >
                <el-radio :disabled="isCatch" :label="false">不限制</el-radio>

                <el-radio :disabled="isCatch" :label="true">
                  限制发送数
                  <el-input
                    :disabled="!formData.isLimitSend || isCatch"
                    oninput="if(this.value=='0'){this.value='';}else{this.value=this.value.replace(/[^0-9]/g,'')}"
                    style="width: 68px; margin-right: 8px"
                    v-model="formData.limitSendNum"
                  ></el-input>
                  <el-tooltip
                    class="item"
                    effect="light"
                    placement="right-start"
                  >
                    <div slot="content" style="color: #666; font-size: 12px">
                      <div style="margin-bottom: 5px">
                        设置该任务每天发送人数的上限
                      </div>
                    </div>
                    <div class="explain">?</div>
                  </el-tooltip>
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="过滤设置:">
              <!-- <el-checkbox-group v-model="formData.filterCondition" :disabled="isCatch"> -->
              <el-checkbox
                v-model="checked1"
                :disabled="isCatch"
                style="margin-right: 5px"
              >
                <span>屏蔽黑名单</span>
              </el-checkbox>
              <span
                @click="
                  () => {
                    if (!isCatch) {
                      routerLinkOne();
                    }
                  }
                "
                style="margin-right: 10px; color: #7f85e9; cursor: pointer"
                >设置黑名单</span
              >
              <el-checkbox v-model="checked2" :disabled="isCatch">
                <span>屏蔽近</span>
                <el-input
                  :disabled="isCatch"
                  v-model.number="formData.filterDays"
                  @keyup.native="limitInput($event)"
                  onblur="value=value.replace(/[^\d]/g,'')"
                  style="width: 100px; padding: 0 6px"
                >
                </el-input>
                <span>天已发送客户</span>
              </el-checkbox>
              <el-checkbox
                v-model="isFilterPeriodBuyer"
                v-if="activityType == 14"
                :disabled="isCatch"
              >
                <span>过滤周期内有购买原商品客户</span>
              </el-checkbox>
              <el-checkbox
                v-model="formData.isFilterFreeGoods"
                v-if="activityType == 14"
                :disabled="isCatch"
              >
                <span>过滤赠送商品</span>
              </el-checkbox>
              <template v-if="activityType == 14">
                <span style="margin-left: 8px;">
                  <el-tooltip
                    placement="top"
                    effect="light"
                    trigger="hover"
                    content="选中后，则会过滤指定商品中作为赠品赠送的商品订单"
                  >
                    <i
                      class="el-icon-question"
                      :style="actIcon ? 'color: red' : ''"
                      @mouseover="actIcon = true"
                      @mouseleave="actIcon = false"
                    ></i>
                  </el-tooltip>
                </span>
              </template>
              <!-- </el-checkbox-group> -->
            </el-form-item>
            <el-form-item label="会员筛选:" v-if="activityType == 14">
              <el-radio
                v-model="formData.memberSelect"
                label="0"
                :disabled="isCatch"
              >
                <span>全部</span>
              </el-radio>
              <el-radio
                v-model="formData.memberSelect"
                label="1"
                :disabled="isCatch"
              >
                <span>只发送会员</span>
              </el-radio>
              <el-radio
                v-model="formData.memberSelect"
                label="2"
                :disabled="isCatch"
              >
                <span>只发送非会员</span>
              </el-radio>
            </el-form-item>
            <el-form-item label="选择商品:" v-if="activityType == 14">
              <div class="bb" style="width: 420px; overflow: hidden">
                <div
                  class="sku_button"
                  style="float: left"
                  @click="selectGoods"
                >
                  选择SKU （已选择
                  <span style="color: #7f85e9">
                    {{ goodsStateLength }}
                  </span>
                  个）
                </div>
              </div>
              <div class="table">
                <el-table
                  :data="tableList"
                  style="width: 150%; margin-top: 22px"
                  :header-cell-style="{
                    background: '#fafafa',
                    'text-align': 'left',
                  }"
                  :cell-style="{ 'text-align': 'left' }"
                >
                  <el-table-column label="商品名称/SKU">
                    <template slot-scope="scope">
                      <div class="goods_box">
                        <img class="img" :src="scope.row.wareLogo" alt="" />
                        <div class="content">
                          <div class="title">{{ scope.row.wareTitle }}</div>
                          <div>SKU ID: {{ scope.row.skuId }}</div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="price"
                    width="100"
                    label="价格"
                  ></el-table-column>
                  <el-table-column
                    width="200"
                    :label="
                      formData.warePeriodType == 1 ? '单个回购周期' : '推荐周期'
                    "
                  >
                    <template slot-scope="scope">
                      <el-input
                        class="cycleInput"
                        v-if="scope.row.isEdit"
                        v-model="scope.row.periodDay"
                        @input="
                          scope.row.periodDay = scope.row.periodDay.replace(
                            /^\.+|[^\d.]/g,
                            ''
                          )
                        "
                      ></el-input>
                      <span v-else>{{ scope.row.periodDay }}</span>
                      <span>天</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        :disabled="isCatch"
                        v-show="!scope.row.isEdit"
                        @click="editOrderCare(scope.row)"
                        type="text"
                        class="edit_btn"
                        >修改</el-button
                      >
                      <el-button
                        :disabled="isCatch"
                        v-show="scope.row.isEdit"
                        @click="editOrderCare(scope.row)"
                        type="text"
                        class="edit_btn"
                        >确定</el-button
                      >
                      <el-button
                        :disabled="isCatch"
                        @click="onDefault(scope.row)"
                        type="text"
                        class="del_btn"
                        >恢复默认</el-button
                      >
                      <el-button
                        :disabled="isCatch"
                        @click="deleteOrderCare(scope.row)"
                        type="text"
                        class="del_btn"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
            <el-form-item
              label="选择商品:"
              v-if="
                activityType == '1' ||
                activityType == '2' ||
                activityType == '4' ||
                activityType == '7'
              "
            >
              <el-radio-group
                :disabled="isCatch"
                v-model="formData.specifyCommodityType"
                @change="switchSpecify"
              >
                <el-radio :label="0"> 全部商品 </el-radio>
                <el-radio :label="1">
                  指定商品
                  <el-button
                    class="search"
                    :disabled="isCatch || formData.specifyCommodityType != '1'"
                    @click="handleShowGoods(true)"
                    >已选择{{ skuList.length }}个</el-button
                  >
                </el-radio>
                <el-radio :label="2">
                  指定sku
                  <el-input
                    style="width: 280px"
                    @input="limitSkuId"
                    :disabled="formData.specifyCommodityType != '2' || isCatch"
                    v-model="skuIdsStr"
                    placeholder="多个SKU之间用英文逗号隔开"
                  ></el-input>
                </el-radio>
              </el-radio-group>
              <div class="select-goods-tips" v-if="activityType == '2'">
                任务发送时间非指定商品的最后交易时间，如需指定商品推荐使用
                <span class="toLink" @click="toLink"
                  >自动化营销模型-商品复购</span
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="step2-box" style="position: relative">
          <div class="step-bar">
            <span class="serial" :style="{ background: globalBG }">2</span>
            <span class="name" style="margin-left: -10px">发送编辑短信</span>
          </div>
          <el-form
            ref="formSearch"
            :model="formData"
            label-width="75px"
            class="step2FormSearch"
          >
            <el-form-item label="短信触达:" v-if="activityType == 14">
              <el-switch
                v-model="formData.isSendSms"
                :disabled="isCatch">
              </el-switch>
            </el-form-item>
            <template v-if="formData.isSendSms">
            <el-form-item label="编辑短信:">
              <div class="textarea">
                <el-input
                  type="textarea"
                  style="font-size: 14px; font-family: Microsoft YaHei"
                  :rows="6"
                  placeholder="请输入内容"
                  :disabled="isCatch"
                  v-model="formData.content"
                  @paste.native="shopLinkCheck($event)"
                ></el-input>
                <div class="footInfo">
                  <div>
                    <button
                      class="select"
                      :disabled="isCatch"
                      @click.prevent="templateShow = true"
                    >
                      选择模板
                    </button>
                    <button
                      class="keep"
                      :disabled="isCatch"
                      @click.prevent="handleShowModule"
                    >
                      保存模板
                    </button>
                    <span>
                      已输入
                      <span :style="{ color: globalBG }">{{
                        sendInfoLength
                      }}</span>
                      个字（含签名及退订文字），预计
                      <span :style="{ color: globalBG }">{{
                        Math.ceil(
                          sendInfoLength > 70
                            ? sendInfoLength / 67
                            : sendInfoLength / 70
                        )
                      }}</span>
                      条短信
                    </span>
                  </div>
                  <div>
                    <div class="ask_content">
                      <span class="askContentBox">计费规则</span>
                      <span class="question_icon" style="margin-left: 4px"
                        >?</span
                      >
                      <div class="ask-icon-select">
                        <div>1.70个字计1条短信，超过70字按照67字每条计费。</div>
                        <div>2.一个汉字，字母或标点空格都算作一个字。</div>
                        <div>
                          3.带标签短信以实际发送为准，有可能超过默认字数。
                        </div>
                        <!-- <div>4."签名"包含在字数中。</div> -->
                        <div>4."签名"与"{{ TTip }}"包含在字数中。</div>
                        <div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>
                        <div>
                          6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="footTips" style="height: 125px; position: relative">
                <img
                  src="@/assets/images/new_icon_waring_yellow.png"
                  style="
                    display: inline-block;
                    float: left;
                    position: absolute;
                    width: 14px;
                    height: 14px;
                    color: #ffffff;
                    margin: 0px 4px 0 0;
                    top: 9px;
                  "
                />
                <span style="margin-left: 15px; line-height: 21px"
                  >（1）短信中短链必须是最新生成的，不可使用测试短链或是复制其他短链；
                  <br />
                  （2）生成短链后建议复制到手机浏览器打开确保短链接能正常打开。
                  <br />
                  （3）包含跳转链接的短信内容需满足以下填写规范：动词+页面名+链接
                  <br />示例：点击加购x商品详情页> 3.cn/1l-dAxxx
                </span>
              </div>
            </el-form-item>
            <el-form-item label="短信签名:">
              <div class="btnList">
                <div
                  class="btnBox"
                  v-for="(item, index) in suffixList"
                  :key="index"
                >
                  <el-button
                    class="btn"
                    style="width: auto; font-size: 14px"
                    @click="switchSuffix(index)"
                    :style="{
                      color: selectSuffix == item ? globalBG : '',
                      'border-color': selectSuffix == item ? globalBG : '',
                    }"
                    >{{ item }}</el-button
                  >
                  <span
                    class="check"
                    :style="{
                      'background-color': selectSuffix == item ? globalBG : '',
                    }"
                  >
                    <i class="el-icon-check"></i>
                  </span>
                </div>

                <span
                  @click="goSuffixUrl"
                  style="
                    fontsize: 14px;
                    cursor: pointer;
                    vertical-align: text-bottom;
                  "
                  :style="{ color: globalBG }"
                  >更换</span
                >
              </div>
            </el-form-item>
            <el-form-item label="辅助工具:">
              <div class="tool">
                <p @click.prevent="handleShowShortLink(1)">
                  <i class="iconfont iconbtn_duanwangzhi"></i>插入短网址
                </p>
              </div>
            </el-form-item>
            <el-form-item label="短信测试:">
              <div class="test">
                <!-- <el-input
                  v-model="mobiles"
                  placeholder="输入测试号码"
                  class="ipt"
                  style="width: 220px"
                  @input="phoneTest"
                ></el-input> -->
                <el-select v-model="Selectmobiles" multiple collapse-tags placeholder="请选择" style="width: 264px;vertical-align: top;" @change="selectTestMobiles">
                  <el-option v-for="item in testOptions" :key="item" :label="item"
                    :value="item"></el-option>
                </el-select>
                <el-button class="sendTest" @click="handleShowSendTip"
                  >发送短信测试</el-button
                >
                <el-button class="record" @click="smsDialogs = true"
                  >短信记录</el-button
                >
                <el-button class="record" style="width:auto;padding-left: 4px;padding-right: 4px;" @click="showchangetestphone = true" >修改测试手机号</el-button>
              </div>
            </el-form-item>
          </template>
          <template v-if="activityType == 14">
          <el-form-item label="咚咚消息:">
            <el-switch
              v-model="formData.isSendDongDong"
              :disabled="isCatch">
            </el-switch>
          </el-form-item>
          <template v-if="formData.isSendDongDong">
            <el-form-item label="发送客服:">
              <el-input
                style="max-width: 548px;"
                placeholder='请输入客服ID，支持最多5个，可用英文"," 分隔'
                @change="handleWaiterInputByformSecond"
                v-model="formData.waiter"
                :disabled="isCatch"
              ></el-input>
              <el-tooltip 
                class="item"
                effect="light"
                content="请从官方客服平台kf.jd.com客服总览获取客服ID"
                placement="top-start"
              >
                <div slot="content">请从官方客服平台 <a href="https://kf.jd.com/" target="_blank">kf.jd.com</a> 客服总览获取客服ID</div>
                <span class="question_icon" style="margin-left: 4px;background-color: #2768FF;border-color:#FFFFFF; color:#ffffff !important;cursor: pointer;">!</span>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="咚咚消息:">
              <div class="textarea">
                <div class="textarea-tools">
                  <div class="textarea-tools-list">
                    <div class="textarea-tools-item">
                      <i class="iconfont iconbtn_duanwangzhi"></i>
                      <button :disabled="isCatch" @click.prevent="handleShowShortLink(2)">插入链接</button>
                    </div>
                  </div>
                </div>
                <div class="textarea-content">
                  <el-input
                    type="textarea"
                    :rows="7"
                    maxlength="140"
                    show-word-limit
                    v-model="formData.dongDongContent"
                    :disabled="isCatch"
                  ></el-input>
                </div>
              </div>
              <div class="footTips" style="margin-top: 10px;height: 65px;position: relative;">
                <img
                  src="@/assets/images/new_icon_waring_yellow.png"
                  style="
                    display: inline-block;
                    float: left;
                    position: absolute;
                    width: 14px;
                    height: 14px;
                    color: #ffffff;
                    margin: 0px 4px 0 0;
                    top: 9px;
                  "
                />
                <span style="line-height: 21px;padding: 0 10px 0 20px">咚咚消息需由官方侧进行人工审核(工作日18:00-20:00审核)，为保证消息在合适时机触达客户，可以设置提前任务</span> 
              </div>
            </el-form-item>
          </template>
          </template>
          </el-form>
          <!-- 短信预览效果 -->
          <div class="xiao-hug xiao_hug2" v-if="formData.isSendSms">
            <div style="margin: 0 auto; width: 256px">
              <div
                class="mobile-box"
                :style="{ background: 'url(' + mobileScreen + ') no-repeat' }"
              >
                <div class="message-content" style>
                  【{{ formData.jdSmsSuffix }}】{{ formData.content }}{{ TTip }}
                </div>
              </div>
              <div class="mobile-tips">短信预览效果</div>
            </div>
          </div>
          <footer class="foot">
            <el-button
              type="primary"
              plain
              class="sendTest"
              @click="handleCancel"
              style="width: 148px; height: 36px; margin-right: 10px"
              >取消</el-button
            >
            <el-button
              type="primary"
              :disabled="createLoading || isCatch"
              @click="handleSave"
              style="width: 148px; height: 36px"
            >
              <i v-show="createLoading" class="el-icon-loading"></i>
              保存
            </el-button>
          </footer>
        </div>
      </div>
    </div>

    <!-- 选择模板 -->
    <sms-template
      v-if="templateShow"
      :isShow="templateShow"
      @close="templateChange"
    ></sms-template>

    <!-- 保存模板 -->
    <my-popup
      title="保存模板"
      width="370"
      zIndex="3330"
      :flag="keepTmpShow"
      @close="keepTmpChange"
    >
      <div class="selectBox">
        <div class="headCnt">
          <span>选择栏目：</span>
          <el-select
            v-model="keepTmpValue"
            placeholder="请选择"
            style="width: 240px"
          >
            <el-option
              v-for="(item, index) in dirList"
              :key="index"
              :label="item.title"
              :value="item.tid"
            ></el-option>
          </el-select>
        </div>
        <button class="keepBtn" @click="keepTmpChange(1)">保存模板</button>
      </div>
    </my-popup>

    <!-- 短信记录 -->
    <sms-template2
      :smsDialog="smsDialogs"
      v-if="smsDialogs"
      @transferName="transferName"
      @close="smsDialogClose"
    ></sms-template2>

    <!-- 插入短链接 -->
    <insert-short-dialog
      v-if="insertShortUrlShow"
      :typeSms="smsType"
      @close="handleCloseShort"
    ></insert-short-dialog>

    <!-- 发送确认弹窗 -->
    <el-dialog
      :visible.sync="showSendConfirm"
      title="发送确认"
      append-to-body
      width="450px"
      custom-class="send-con-dialog"
    >
      <div>
        <span>提交号码为 {{ phoneLenght }}</span>
        ，当前短信字数为
        <span :style="{ color: globalBG }">{{ sendInfoLength }}</span>
        字，每条短信以
        <span :style="{ color: globalBG }">{{
          Math.ceil(
            sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70
          )
        }}</span>
        条计费，提交
        <span :style="{ color: globalBG }">{{
          phoneLenght *
          Math.ceil(
            sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70
          )
        }}</span>
        条短信，以实际发送条数为准！
      </div>
      <div class="btn-group">
        <el-button type="primary" @click="handleSendConfirm">发送</el-button>
        <el-button @click="showSendConfirm = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 选择商品弹窗 -->
    <select-goods v-if="isShowGoods" :isShow="isShowGoods" :selectGoods="skuList" :skuSearch="true"
      @close="selectGoodsChange" :moduleType="true"></select-goods>

    <el-dialog title="提示" width="650px" :visible.sync="isAdvanced">
      <div>
        <span
          ><i class="el-icon-info" :style="{ color: globalBG }"></i
          >该功能为高级版功能，请先订购云短信高级版
        </span>
        <span
          style="cursor: pointer"
          :style="{ color: globalBG }"
          @click="toDingGou"
          >去订购>></span
        >
      </div>
      <div class="footer">
        <button
          class="confirm"
          @click="isAdvanced = false"
          style="margin: 10px auto 0"
        >
          确定
        </button>
      </div>
    </el-dialog>
    <changetestphone :textPhoneId="textPhoneId" :nowtestMobiles="nowtestMobiles" v-if="showchangetestphone" @close="showchangetestphone = false" @mobilPhoneSubmit="mobilPhoneSubmit"></changetestphone>
  </div>
</template>

<script>
import selectGoods from "@/components/selectGoodsMonitor2";
import { createMarketing } from "@/api/marketing/autoMarketingO";
import { mapState } from "vuex";
import insertShortDialog from "@/components/insert-short-dialog";
import { preCommit,NewPreCommit, precisionMarketing, platformSend,getValidSmsTestMobiles } from "@/api/smsSend";
import myPopup from "@/components/myPopup";
import smsTemplate from "@/views/serviceCenter/sms_template";
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import { getTemplateDir, createTemplate } from "@/api/smsTemplates";
import smsTemplate2 from "@/components/sms-templates-x.vue";
import dropdownDateMultipleSelection from "./dropdown-date-multiple-selection.vue";
import changetestphone from "@/components/changetestphone.vue";
export default {
  name: "create-task-official",
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    sendInfoLength() {
      return (
        this.formData.content.length +
        this.formData.jdSmsSuffix.length +
        2 +
        this.TTip.length
      );
    },
  },
  props: {
    activityType: {
      type: Number,
      default: 1,
    },
    detailObj: {
      type: Object,
      default: {},
    },
    copyIsfaly: {
      type: Boolean,
      default: false,
    },
    isPeriod:{
      type: Boolean,
      default: false,
    },
  },
  watch: {
    formData: {
      handler: function(newVal, old){
        this.formData = newVal;
      },
      deep: true,
    }
  },
  components: {
    smsTemplate,
    myPopup,
    smsTemplate2,
    insertShortDialog,
    selectGoods,
    dropdownDateMultipleSelection,
    changetestphone
  },
  data() {
    return {
      textPhoneId:"",
      nowtestMobiles:"",
      showchangetestphone:false,
      testOptions: [], // 获取测试手机号
      Selectmobiles:[],
      isAdvanced:false,//高级版判断
      titleList: [
        "",
        "首购有礼",
        "复购有礼",
        "流失客户召回",
        "兴趣客户转化",
        "开卡未购会员转化",
        "已购客户开卡转化",
        "直播提醒",
        "店铺上新提醒",
        "会员专享活动提醒",
        "会员积分使用提醒",
        "沉默会员召回-行业活跃",
        "店铺预售高潜人群关怀",
        "算法大促高转化人群营销",
        "商品复购",
        "会员生日提醒",
        "会员日营销",
        "京享值用户兴趣转化",
        "京东plus会员营销",
        "储值卡用户提醒",
      ],
      SendObjectText1: ["", "", "", "", "", "开卡满", "近", "近"],
      SendObjectText2: [
        "",
        "",
        "",
        "",
        "",
        "次，但从未在店铺下单购买的用户",
        "天内已购买未开卡的用户",
        "天，在直播间下单过的用户",
      ],
      smsType: 2, // 官方
      insertShortUrlShow: false, // 插入短链接状态控制 ----- 内容
      mobileScreen: require("@/assets/images/mobileScreen.png"),
      phoneLenght: 0, // 提交号码数量
      showSendConfirm: false,
      smsDialogs: false,
      mobiles: "",
      suffixList: [],
      selectSuffix: "",

      keepTmpShow: false,
      keepTmpValue: "",
      dirList: [],

      TTip: "拒收请回复R",
      templateShow: false,
      jdShortLinkList: [],
      checked1: false,
      checked2: false,
      // sendInfoLength: 0,
      formData: {
        activityName: "",
        activityStartTime: "",
        activityEndTime: "",
        sendTime: "10:00:00",
        content: "",
        jdSmsSuffix: "",
        filterCondition: [],
        filterDays: "",
        lastBuyAfterDays: null,
        lastBuyAfterEndDays: null,
        jdShortLink: "", // 短信签名
        userActDayStart: 3,
        last30daysPvMore: null,
        isLimitSend: false,
        isOneDayBirth: true,
        limitSendNum: "",
        userActDayEnd: 15,
        specifyCommodityType: 0, // 选择商品类型
        userActNumStart: 3,
        userActNumEnd: 15,
        sendObject: 0,
        warePeriodType: 1, // (1:回购型，2:推荐型)
        // 回购型
        wareConsumeType: "0", // 商品消耗时段
        sendConditionDay: 3, // 回购型商品消耗发送时间:天
        sendConditionHour: 10, // 发送时间:时
        memberSelect: "0", // 会员筛选  0全部  1只发送会员   2只发送非会员
        // 会员发送时间
        cycleDayMonthly: "",
        // 会员开卡时间
        userActDateSelectType: 0,
        userActDateStart: "",
        userActDateEnd: "",
        // 会员开卡时间相对时间
        relativeDayStart: "",
        relativeDayEnd: "",
        // 会员积分
        memberPointsType: 0,
        userActNumStart: "",
        userActNumEnd: "",
        // 会员等级：
        memberLevel: ["1", "2", "3", "4", "5"],
        userValue: ["4", "3", "2", "1"],

        // 京享值人群
        jdGroupType: 1,
        jdGroupMin: "5000",
        jdGroupMax: "",
        isjdDays: true,
        isShowDays: "7",

        // 京东plus
        plusLevel: ["-1", "2", "3", "4", "5", "6"],
        level2: ["-1","1", "2", "3", "4", "5"],

        // 充值时间
        reChangeTimeType: 0,
        reChangeMinTime: this.getOneYearAgo(),
        reChangeMaxTime: this.getNewDay(),
        // dates: "",
        // 充值次数
        rechargeTimeType: 0,
        rechargeFirst: 0,
        rechargeEnd: 10,
        // 充值金额
        rechargeAmountType: 0,
        userActAmountStart: 0,
        userActAmountEnd: 1000,
        cardType: 0,
        userActAmountStart2: 0,
        userActAmountEnd2: 10000,

        // 过滤赠送商品
        isFilterFreeGoods: false,
        // 是否发送短信
        isSendSms: true,
        // 咚咚消息
        isSendDongDong: false,
        waiter: '',
        dongDongContent: '',
      },
      // 开发时间选择器
      areaSelectTime: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "大于等于",
          value: 1,
        },
        {
          label: "小于等于",
          value: 2,
        },
        {
          label: "相对时间",
          value: 3,
        },
      ],
      // 会员积分、京享值选择器
      areaSelect: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "大于等于",
          value: 1,
        },
        {
          label: "小于等于",
          value: -1,
        },
      ],
      //
      areaSelectTime2: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "日期",
          value: 4,
        },
      ],
      membershipOpenMinTimeOption: {
        disabledDate: (date) => {
          var activityEndTime = this.formData.userActDateEnd;
          var time = date.getTime();
          var isDisabled = false;
          if (activityEndTime) {
            isDisabled = time > new Date(activityEndTime).getTime();
          }
          if (time > Date.now() - 8.64e7 + 3600 * 1000 * 24 * 1) {
            isDisabled = true;
          }
          return isDisabled;
        },
      },
      membershipOpenMaxTimeOption: {
        disabledDate: (date) => {
          var activityStartTime = this.formData.userActDateStart;
          var time = date.getTime();
          var isDisabled = false;
          if (activityStartTime) {
            isDisabled = time < new Date(activityStartTime).getTime();
          }
          if (time > Date.now() - 8.64e7 + 3600 * 1000 * 24 * 1) {
            isDisabled = true;
          }
          return isDisabled;
        },
      },
      membershipOpeningTimeOption: [
        {
          value: "0",
          label: "区间",
        },
        {
          value: "1",
          label: "大于等于",
        },
        {
          value: "2",
          label: "小于等于",
        },
      ],
      membershipOpeningTimeOption2: [
        {
          value: "0",
          label: "区间",
        },
        {
          value: "1",
          label: "大于等于",
        },
        {
          value: "2",
          label: "小于等于",
        },
      ],
      memberList: [
        {
          value: "1",
          label: "一星会员",
        },
        {
          value: "2",
          label: "二星会员",
        },
        {
          value: "3",
          label: "三星会员",
        },
        {
          value: "4",
          label: "四星会员",
        },
        {
          value: "5",
          label: "五星会员",
        },
      ],
      memberPointsStartTimeOption: {
        disabledDate: (date) => {
          var activityEndTime = this.formData.memberPointsEndTimeOption;
          var time = date.getTime();
          var isDisabled = false;
          if (activityEndTime) {
            isDisabled = time > new Date(activityEndTime).getTime();
          }
          // if (time < Date.now() - 8.64e7) {
          //   isDisabled = true;
          // }
          return isDisabled;
        },
      },
      memberPointsEndTimeOption: {
        disabledDate: (date) => {
          var activityStartTime = this.formData.memberPointsStartTimeOption;
          var time = date.getTime();
          var isDisabled = false;
          if (activityStartTime) {
            isDisabled = time < new Date(activityStartTime).getTime();
          }
          // if (time < Date.now() - 8.64e7) {
          //   isDisabled = true;
          // }
          return isDisabled;
        },
      },
      // 会员价值
      actIcon: false,
      mebershipValueOption: [
        {
          value: "4",
          label: "非常高",
        },
        {
          value: "3",
          label: "高",
        },
        {
          value: "2",
          label: "低",
        },
        {
          value: "1",
          label: "非常低",
        },
      ],
      // 京享值人群
      jdGroupOption: [
        {
          value: "0",
          label: "区间",
        },
        {
          value: "1",
          label: "大于等于",
        },
        {
          value: "2",
          label: "小于等于",
        },
      ],
      // plus会员状态
      plusOption: [
        {
          value: "-1",
          label: "未试用",
        },
        {
          value: "2",
          label: "试用中",
        },
        {
          value: "3",
          label: "试用过期",
        },
        {
          value: "4",
          label: "未激活",
        },
        {
          value: "5",
          label: "正式中",
        },
        {
          value: "6",
          label: "正式过期",
        },
      ],
      levelOption: [
        {
          value: '-1',
          label: "未识别",
        },
        {
          value: '1',
          label: "一星会员",
        },
        {
          value: '2',
          label: "二星会员",
        },
        {
          value: '3',
          label: "三星会员",
        },
        {
          value: '4',
          label: "四星会员",
        },
        {
          value: '5',
          label: "五星会员",
        },
      ],
      reChangeMinTimeOption: {
        disabledDate: (date) => {
          var activityEndTime = this.formData.reChangeMaxTime;
          var time = date.getTime();
          var isDisabled = false;
          if (activityEndTime) {
            isDisabled = time > new Date(activityEndTime).getTime();
          }
          if (time > Date.now() - 8.64e7 + 3600 * 1000 * 24 * 1) {
            isDisabled = true;
          }
          return isDisabled;
        },
      },
      reChangeMaxTimeOption: {
        disabledDate: (date) => {
          var activityStartTime = this.formData.reChangeMinTime;
          var time = date.getTime();
          var isDisabled = false;
          if (activityStartTime) {
            isDisabled = time < new Date(activityStartTime).getTime();
          }
          if (time > Date.now() - 8.64e7 + 3600 * 1000 * 24 * 1) {
            isDisabled = true;
          }
          return isDisabled;
        },
      },
      goodsStateLength: 0, // 已选商品
      isFilterPeriodBuyer: false, // 过滤周期内有购买原商品客户
      options: [
        {
          value: "-1",
          label: "前",
        },
        {
          value: "0",
          label: "当天",
        },
        {
          value: "1",
          label: "后",
        },
      ],
      tableList: [],
      originIds: [],
      createLoading: false,
      isCatch: false, // 是否为查看
      startTimeOption: {
        disabledDate: (date) => {
          var activityEndTime = this.formData.activityEndTime;
          var time = date.getTime();
          var isDisabled = false;
          if (activityEndTime) {
            isDisabled = time > new Date(activityEndTime).getTime();
          }
          if (time < Date.now() - 8.64e7) {
            isDisabled = true;
          }
          return isDisabled;
        },
      },
      endTimeOption: {
        disabledDate: (date) => {
          var activityStartTime = this.formData.activityStartTime;
          var time = date.getTime();
          var isDisabled = false;
          if (activityStartTime) {
            isDisabled = time < new Date(activityStartTime).getTime();
          }
          if (time < Date.now() - 8.64e7) {
            isDisabled = true;
          }
          return isDisabled;
        },
      },
      sendTimeDate: {
        selectableRange: "10:00:00 - 19:55:59",
      },
      skuList: [],
      skuIdsStr: "",
      isShowGoods: false,
      groups: [
        { label: "1-7", options: Array.from({ length: 7 }, (_, i) => i + 1) },
        { label: "8-14", options: Array.from({ length: 7 }, (_, i) => i + 8) },
      ],
      actIcon: false,
      isDDUrl: false, //是否在咚咚消息插入
    };
  },
  mounted() {
    this.getOfficialSuffix();
    this.getValidSmsTestMobiles()
    console.log("this.detailObj------>", this.detailObj);
    if (this.detailObj.id) {
      this.formData = this.detailObj;
      this.checked1 = this.detailObj.filterBlacklistFlag ? true : false;
      this.checked2 = this.detailObj.filterAlreadySentFlag ? true : false;

      this.TTip;
      var index = this.formData.content.indexOf(this.TTip);
      if (index != "-1") {
        this.formData.content = this.formData.content.substr(0, index);
      }
      var specifyCommodityType = this.detailObj.specifyCommodityType;
      if (specifyCommodityType == "1") {
        this.skuList = this.detailObj.skus;
      } else if (specifyCommodityType == "2") {
        this.skuIdsStr = this.detailObj.skuIds;
      }
      // console.log(this.formData, 555);
      if (!this.copyIsfaly) this.isCatch = true;
      if (this.activityType == "14") {
        // 商品复购
        this.formData.isFilterFreeGoods = this.detailObj.isFilterFreeGoods;
      }
      if (this.activityType == "15") {
        // 会员生日提醒
        if (this.detailObj.userActDayStart == 0) {
          this.formData.isOneDayBirth = true;
          this.formData.userActDayEnd = this.formData.userActDayStart = "";
        } else {
          this.formData.isOneDayBirth = false;
        }
      }
      // 会员日营销 TODO:数据回显格式处理
      if (this.activityType == "16"){
        // 发送时间
        this.formData.cycleDayMonthly = this.detailObj.cycleDayMonthly || '';
        // 开卡时间
        this.formData.userActDateSelectType = Number(this.detailObj.userActDateSelectType);
        this.formData.userActDateStart = this.detailObj.userActDateStart;
        this.formData.userActDateEnd = this.detailObj.userActDateEnd;
        // 相对时间
        this.formData.relativeDayStart = this.detailObj.userActDayStart;
        this.formData.relativeDayEnd = this.detailObj.userActDayEnd;
        // 会员积分
        // this.formData.memberPointsType = this.detailObj.memberPointsType;
        if((this.detailObj.userActNumStart == ''  || this.detailObj.userActNumStart == null ) && this.detailObj.userActNumEnd != ''){
          // 小于等于
          this.formData.memberPointsType = -1;
        }else if(this.detailObj.userActNumStart != '' && (this.detailObj.userActNumEnd == '' || this.detailObj.userActNumEnd == null  )){
          // 大于等于
          this.formData.memberPointsType = 1;
        }else {
          // 区间
          this.formData.memberPointsType = 0;
        }
        this.formData.userActNumStart = this.detailObj.userActNumStart;
        this.formData.userActNumEnd = this.detailObj.userActNumEnd;
        // 会员等级
        let memberLevelData = this.detailObj.memberLevel || '';
        this.formData.memberLevel = memberLevelData.split(",");
        // 会员价值
        let userValueData = this.detailObj.userValue || '';
        this.formData.userValue = userValueData.split(",");
        this.$forceUpdate();
      }
      // 京享值用户兴趣转化
      if (this.activityType == "17"){
        // 京享值人群
        // this.formData.jdGroupType = this.detailObj.jdGroupType;
        this.formData.jdGroupMin = this.detailObj.userActNumStart;
        this.formData.jdGroupMax = this.detailObj.userActNumEnd;
        if((this.detailObj.userActNumStart == '' || this.detailObj.userActNumStart == null) && this.detailObj.userActNumEnd != ''){
          // 小于等于
          this.formData.jdGroupType = -1;
        }else if(this.detailObj.userActNumStart != '' && (this.detailObj.userActNumEnd == '' || this.detailObj.userActNumEnd == null)){
          // 大于等于
          this.formData.jdGroupType = 1;
        }else {
          // 区间
          this.formData.jdGroupType = 0;
        }
        // 是否勾选近几天
        let lastDaysAddCartFollowFlag = this.detailObj.lastDaysAddCartFollowFlag;
        if(lastDaysAddCartFollowFlag == 1){
          this.formData.isjdDays = true;
        }else {
          this.formData.isjdDays = false;
        }
        this.formData.isShowDays = this.detailObj.userActDayStart;
      }
      // 京东plus会员营销
      if (this.activityType == "18"){
        let plusUserStage = this.detailObj.plusUserStage || '';
        let arr = plusUserStage.split(",");
        // this.formData.plusLevel = this.copyArr(arr);
        this.formData.plusLevel = arr;
        let memberLevelData = this.detailObj.memberLevel || '';
        this.formData.level2 = memberLevelData.split(",");
      }
      // 储值用户提醒
      if (this.activityType == "19"){
        // 充值时间
        this.formData.reChangeMinTime = this.detailObj.userActDateStart;
        this.formData.reChangeMaxTime = this.detailObj.userActDateEnd;
        this.$forceUpdate();
        console.log("1111",this.formData.reChangeMinTime, this.formData.reChangeMaxTime );

        // 充值次数
        if((this.detailObj.userActNumStart == ''  || this.detailObj.userActNumStart == null) && this.detailObj.userActNumEnd != ''){
          // 小于等于
          this.formData.rechargeTimeType = -1;
        }else if(this.detailObj.userActNumStart != '' && (this.detailObj.userActNumEnd == ''  || this.detailObj.userActNumEnd == null)){
          // 大于等于
          this.formData.rechargeTimeType = 1;
        }else {
          // 区间
          this.formData.rechargeTimeType = 0;
        }
        this.formData.rechargeFirst = this.detailObj.userActNumStart;
        this.formData.rechargeEnd = this.detailObj.userActNumEnd;

        // 充值金额
        if((this.detailObj.userActAmountStart == ''  || this.detailObj.userActAmountStart == null ) && this.detailObj.userActAmountEnd != ''){
          // 小于等于
          this.formData.rechargeAmountType = -1;
        }else if(this.detailObj.userActAmountStart != '' && (this.detailObj.userActAmountEnd == '' || this.detailObj.userActAmountEnd == null )){
          // 大于等于
          this.formData.rechargeAmountType = 1;
        }else {
          // 区间
          this.formData.rechargeAmountType = 0;
        }
        this.formData.userActAmountStart = this.detailObj.userActAmountStart;
        this.formData.userActAmountEnd = this.detailObj.userActAmountEnd;

        // 储值卡余额
        if((this.detailObj.userActAmountStart2 == ''  || this.detailObj.userActAmountStart2 == null  ) && this.detailObj.userActAmountEnd2 != ''){
          // 小于等于
          this.formData.cardType = -1;
        }else if(this.detailObj.userActAmountStart2 != '' && (this.detailObj.userActAmountEnd2 == ''  || this.detailObj.userActAmountEnd2 == null  )){
          // 大于等于
          this.formData.cardType = 1;
        }else {
          // 区间
          this.formData.cardType = 0;
        }
        this.formData.userActAmountStart2 = this.detailObj.userActAmountStart2;
        this.formData.userActAmountEnd2 = this.detailObj.userActAmountEnd2;
      }
    } else {
      if (this.activityType == "2") {
        // 复购
        this.formData.lastBuyAfterDays = 30;
      } else if (this.activityType == "3") {
        // 客户流失召唤
        this.formData.lastBuyAfterDays = 180;
        this.formData.lastBuyAfterEndDays = 180;
        this.formData.isLimitSend = false;
      } else if (this.activityType == "14") {
        // 商品复购
        this.checked1 = true;
        this.formData.isSendDongDong = true; // 默认发送到咚咚
      } else if (this.activityType == "15") {
        // 会员生日提醒
        this.formData.userActDayEnd = this.formData.userActDayStart = "";
      }
    }
    if (this.activityType == 14) {
      console.log("666------>", this.formData);
      let originIds = [];
      if (this.formData.warePeriodList && this.formData.warePeriodList.length) {
        this.skuList = this.formData.warePeriodList.map((i) => {
          originIds.push(i.wareId);
          return {
            ...i,
            isAdd: true,
            logo: i.wareLogo,
            jdPrice: i.price,
            skuName: i.wareTitle,
          };
        });
        this.originIds = originIds;
        this.tableList = this.formData.warePeriodList.map((item) => {
          return {
            ...item,
            isEdit: false,
          };
        });
      }
      this.formData.sendConditionHour = this.formData.sendTime.substring(0, 2);
      this.formData.wareConsumeType = String(this.formData.wareConsumeType);
      this.formData.sendConditionDay = String(
        this.formData.sendConditionDay ? this.formData.sendConditionDay : ""
      );
      this.formData.memberSelect = String(this.formData.memberSelect);
      this.goodsStateLength = this.formData.warePeriodList
        ? this.formData.warePeriodList.length
        : 0;
      this.isFilterPeriodBuyer = this.formData.isFilterPeriodBuyer;
    }
    console.log("this.isCatch", this.isCatch);
    console.log("this.copyIsfaly", this.copyIsfaly);
    if (this.isCatch == false && !this.copyIsfaly) {
      this.dateActive();
    }
    if (!this.isCatch && !this.copyIsfaly) {
      let d = new Date();
      this.formData.activityName =
        this.titleList[this.activityType] +
        this.dateFormat(d.getTime() + 500000);
    }
  },
  methods: {
    handleWaiterInputByformSecond(){
      let ids = this.formData.waiter.split(',').filter(id => id.trim() !== '');
      if (ids.length > 5) {
        ids = ids.slice(0, 5); // 截取前5个ID
        this.formData.waiter = ids.join(','); // 拼接成字符串，覆盖原输入
        this.$message.error("最多只能输入5个客服ID");
      }
    },
    mobilPhoneSubmit(val){
      this.getValidSmsTestMobiles()
      this.showchangetestphone = false
    },
    getValidSmsTestMobiles() {
      // 获取测试手机号
      getValidSmsTestMobiles().then(res => {
        if (res.code == 1) {
          this.Selectmobiles = [];
          this.testOptions = res.data.smsTestMobiles
          this.nowtestMobiles = res.data.smsTestMobiles.join(',')
          this.textPhoneId = res.data.id
        }
      })
    },
    // 短信测试手机号 
    selectTestMobiles(val) {
      this.mobiles = this.Selectmobiles.join(',')
    },
    inputLast(value) {
      let num = value.replace(/[^\d]/g, "").replace(/^0+(\d)/, "$1");
      return num;
    },
    limitInput1(event) {
      var reg = /^([1-9][0-9]*)$/;
      if (reg.test(event.target.value)) {
        //只能输入大于0的正整数
      } else {
      }
    },
    changeForceUpdate() {
      this.$forceUpdate();
    },

    selectGoods() {
      if (this.isCatch) {
        return;
      }
      this.isShowGoods = true;
    },

    // 复购有礼跳转到商品复购
    toLink() {
      console.log("isPeriod",this.isPeriod)
      if(!this.isPeriod){
        this.isAdvanced = true
      }else{
        this.$parent.showTaskOfficial = false
        setTimeout(() => {
          this.$parent.showTaskOfficial = true
          this.$parent.newBtn(this.$parent.officialListitem[0].list[6])
        }, 10)
      }
    },

    editOrderCare(item) {
      item.isEdit = !item.isEdit;
    },

    onDefault(item) {
      if (
        item.defaultPeriodDay !== null &&
        item.defaultPeriodDay !== undefined
      ) {
        item.periodDay = item.defaultPeriodDay;
      } else {
        this.$http
          .get("/ware/getItemBuyerRebuyAvg", {
            params: {
              numIid: item.skuId + "",
            },
          })
          .then((res) => {
            let defaultPeriodDay = res.data;
            item.periodDay = defaultPeriodDay;
            item.defaultPeriodDay = defaultPeriodDay;
          });
      }
    },
    deleteOrderCare(item) {
      let index = this.tableList.findIndex((i) => i.skuId == item.skuId);
      this.tableList.splice(index, 1);
      this.skuList.splice(index, 1);
      this.goodsStateLength--;
    },

    sendConditionTips() {
      if (this.formData.sendCondition == "") {
        this.$message.error("发送时间不允许为空");
      }
    },

    wareChange(val) {
      if (val == "0") {
        this.formData.sendConditionDay = 0;
      }
    },

    // 单选框监听事件
    wareType() {
      this.formData.wareConsumeType = "0";
      this.formData.sendConditionDay = "";
      this.formData.sendConditionHour = "";
    },

    switchSpecify(val) {
      if (val == "1") {
        // 商品弹窗
        this.skuIdsStr = "";
      } else if (val == "2") {
        // sku
        this.skuList = [];
      } else {
        this.skuIdsStr = "";
        this.skuIdsStr = [];
      }
    },
    // 限制skuid 最多输入100个
    limitSkuId() {
      var value = this.skuIdsStr;
      var reg = /[^\d,\s]/g;
      if (reg.test(value)) {
        value = value.replace(reg, "");
      }

      this.skuIdsStr = value.replace(/\s+/g, "");
      var limitLength = 100;
      var valueList = value.replace(/[^\d\,]/g, "").split(",");
      if (valueList.length > limitLength) {
        this.skuIdsStr = valueList.slice(0, limitLength).join(",");
      }
    },
    selectGoodsChange(val) {
      console.log("val------>", val);
      if (val) {
        if (val.length > 100) {
          this.$message.warning("sku上限为100个！");
          return;
        }
        this.skuList = val;
        if (this.activityType == 14) {
          // 商品复购额外处理
          let goodsArr = [];
          for (let item of val) {
            let obj = {};
            obj.wareTitle = item.wareTitle || item.title;
            obj.price = item.jdPrice;
            obj.skuId = item.skuId;
            obj.wareId = item.wareId;
            obj.wareLogo = item.logo;
            obj.isEdit = false;
            obj.periodDay = item.periodDay;
            // obj.defaultPeriodDay = item.periodDay;
            goodsArr.push(obj);
          }

          // 商品复购周期
          Promise.all(
            goodsArr.map((item) =>
              this.$http.get("/ware/getItemBuyerRebuyAvg", {
                params: { numIid: item.skuId + "" },
              })
            )
          ).then((res) => {
            console.log("Promise.all---->", res);
            goodsArr.map((item, index) => {
              if (this.originIds.indexOf(item.wareId) == "-1") {
                item.periodDay = res[index].data; //复购周期
                //默认复购周期
              }
              item.defaultPeriodDay = res[index].data;
            });
            this.goodsStateLength = val.length;
            this.tableList = goodsArr;
          });
        }
      }
      this.isShowGoods = false;
    },
    handleShowGoods() {
      this.isShowGoods = true;
    },
    handleLimitSend() {
      this.formData.limitSendNum = "";
    },
    limitInput(event) {
      if (event.target.value == "0") {
        event.target.value = "";
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g, "");
      }
    },
    //时间格式化函数
    dateFormat(time) {
      let date = new Date(time);
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    dateActive() {
      let d = new Date();
      this.formData.activityName =
        this.titleList[this.activityType] +
        this.dateFormat(d.getTime() + 500000);
      this.formData.activityStartTime = this.dateFormat(d.getTime() + 500000);
      this.formData.activityEndTime = this.dateFormat(
        d.getTime() + 86400000 * 30
      );
    },
    // 关闭短链接
    handleCloseShort(val, obj) {
      this.insertShortUrlShow = false;
      console.log(obj);
      
      if(this.isDDUrl){
        this.isDDUrl = false;
        if (val) {
          this.formData.dongDongContent = this.formData.dongDongContent + " " + obj.shortLink + " ";
        }
        return
      }

      if (val) {
        this.formData.jdShortLink = obj.shortLink;
        this.formData.url = obj.originUrl;
        this.formData.content =
          this.formData.content + " " + obj.shortLink + " ";
      }
    },

    handleShowShortLink(type) {
      if (this.isCatch) {
        return;
      }
      if(type==2) {
        this.isDDUrl = true;
      }
      this.insertShortUrlShow = true;
    },
    handleSave() {
      var formData = this.formData;
      var filterCondition = formData.filterCondition;
      var param = {
        activityType: this.activityType,
        filterBlacklistFlag: false,
        filterAlreadySentFlag: false,
        // filterDays: formData.filterDays,
        activityName: formData.activityName,
        activityStartTime: formData.activityStartTime,
        activityEndTime: formData.activityEndTime,
        sendTime: formData.sendTime,
        content: formData.content + this.TTip,
        url: formData.url,
        jdShortLink: formData.jdShortLink,
        jdSmsSuffix: formData.jdSmsSuffix,
        isLimitSend: formData.isLimitSend,
        limitSendNum: formData.limitSendNum,
        userActDayStart: formData.userActDayStart, //Note:客户兴趣转化，发送对象无时间值问题 (21/9/15)
        userActDayEnd: formData.userActDayEnd, //Note:客户兴趣转化，发送对象无时间值问题 (21/9/15)
        userActNumStart: formData.userActNumStart,
        userActNumEnd: formData.userActNumEnd,
        isSendSms: formData.isSendSms,
        isSendDongDong: formData.isSendDongDong,
        waiter: formData.waiter,
        dongDongContent: formData.dongDongContent,
      };
      if(!this.formData.isSendDongDong && !this.formData.isSendSms){
        this.$message.error("短信触达和咚咚消息触达，至少设置开启一个");
        return;
      }

      if(this.formData.isSendSms) {
        if (!this.formData.content) {
          this.$message.warning("短信内容不能为空哦！");
          return;
        }
      }

      if(this.formData.isSendDongDong) {
        if (!this.formData.waiter) {
          this.$message.warning("发送客服不能为空");
          return;
        }
        if (!this.formData.dongDongContent) {
          this.$message.warning("咚咚内容不能为空哦！");
          return;
        }
      }
      
      if (this.formData.isLimitSend && this.formData.limitSendNum < 2) {
        this.$message.error("限制发送数必须大于大于2");
        return;
      }
      if (this.activityType == 2) {
        param.sendObject = formData.sendObject;
      }
      //是有商品的情况下
      if (
        this.activityType == 1 ||
        this.activityType == 2 ||
        this.activityType == 4 ||
        this.activityType == 7
      ) {
        param["specifyCommodityType"] = formData.specifyCommodityType;
        var type = formData.specifyCommodityType;
        if (type == "1") {
          if (!this.skuList || this.skuList.length == "0") {
            this.$message.warning("请选择商品！");
            return;
          }
          // 指定商品
          var skuIds = this.skuList.map((item) => {
            return item.skuId;
          });
          param["skuIds"] = skuIds.join(",");
        } else if (type == "2") {
          if (!this.skuIdsStr) {
            this.$message.warning("请输入skuId！");
            return;
          }
          param["skuIds"] = this.skuIdsStr;
        } else {
          param["skuIds"] = "";
        }
      }
      if (this.activityType == 3) {
        console.log();
        if (
          Number(formData.lastBuyAfterDays) >
            Number(formData.lastBuyAfterEndDays) &&
          formData.lastBuyAfterEndDays
        ) {
          this.$message.warning("发送时间天数起始值不能大于结束值");
          return;
        }
        if (!formData.lastBuyAfterDays && !formData.lastBuyAfterEndDays) {
          this.$message.warning("发送时间必填一个起始值和结束值");
          return;
        }
        param.lastBuyAfterEndDays = formData.lastBuyAfterEndDays;
      }
      if (this.activityType == 4) {
        if (
          formData.userActDayStart <= 0 ||
          formData.userActDayEnd <= 0 ||
          formData.userActDayEnd < formData.userActDayStart
        ) {
          this.$message.warning("发送对象的时间无效");
          return;
        }
        param.userActDayStart = formData.userActDayStart;
        param.userActDayEnd = formData.userActDayEnd;
      }
      if (
        this.activityType == 5 ||
        this.activityType == 6 ||
        this.activityType == 7
      ) {
        console.log("进入赋值");
        if (formData.userActDayStart <= 0) {
          this.$message.warning("发送对象的时间无效");
          return;
        }
        param.userActDayStart = formData.userActDayStart;
        param.userActDayEnd = formData.userActDayStart; //暂时用开始值
      }
      if (this.activityType == 5) {
        param.last30daysPvMore = formData.last30daysPvMore;
      }

      if (this.activityType == 10) {
        param.userActDayStart = "";
        param.userActDayEnd = ""; //除去类型的其他值
        if (
          formData.userActNumStart <= 0 ||
          formData.userActNumEnd <= 0 ||
          formData.userActNumEnd < formData.userActNumStart
        ) {
          this.$message.warning("发送对象的区间无效");
          return;
        }
        param.userActNumStart = formData.userActNumStart;
        param.userActNumEnd = formData.userActNumEnd;
      } else {
        param.userActNumStart = "";
        param.userActNumEnd = "";
      }

      // 商品复购参数
      if (this.activityType == 14) {
        param.warePeriodType = formData.warePeriodType;
        if (param.warePeriodType == 1) {
          // 回购型传：消耗发送类型以及消耗天数
          param.wareConsumeType = formData.wareConsumeType;
          if (param.wareConsumeType == 0) {
            param.wareConsumeDay = "";
          } else {
            param.wareConsumeDay = formData.sendConditionDay;
          }
        } else {
          param.wareConsumeType = "";
          param.wareConsumeDay = "";
        }
        if (
          param.warePeriodType == 1 &&
          param.wareConsumeType != 0 &&
          param.wareConsumeDay == ""
        ) {
          return this.$message.warning("请选择商品消耗天数");
        }
        param.warePeriodType = formData.warePeriodType;
        param.sendTime = formData.sendTime;
        // param.sendTime = Number(formData.sendConditionHour) > 9 ? (formData.sendConditionHour + ":00:00") : ("0" + formData.sendConditionHour + ":00:00");
        // if(Number(this.formData.sendConditionHour) < 10 || Number(this.formData.sendConditionHour) > 19) {
        //   return this.$message.error("发送时间范围在10至19之间")
        // }
        param.isFilterPeriodBuyer = this.isFilterPeriodBuyer;
        param.isFilterFreeGoods = this.formData.isFilterFreeGoods;
        param.memberSelect = formData.memberSelect;
        if (!this.tableList.length) {
          return this.$message.error("请选择商品");
        }
        param.warePeriodList = this.tableList.map((item) => {
          return {
            periodDay: item.periodDay,
            price: item.price,
            skuId: item.skuId,
            wareId: item.wareId,
            wareLogo: item.wareLogo,
            wareTitle: item.wareTitle,
          };
        });
        const isCondition = param.warePeriodList.every((item) => {
          return Number(item.periodDay);
        });
        if (!isCondition) {
          return this.$message.warning(
            `${
              param.warePeriodType == 1 ? "单个回购周期" : "商品推荐周期"
            }不得为0`
          );
        }
        if (param.sendTime == "") {
          return this.$message.warning("请输入每天发送时间");
        }
        if (this.isCatch && param.limitSendNum == "") {
          return this.$message.warning("请输入屏蔽天数");
        }
        // 通过开关判断是否需要传送短信内容，以免造成误解
        if(!this.formData.isSendSms){
          param.content = "";
        }
        if(!this.formData.isSendDongDong) {
          param.dongDongContent = "";
        }
      }

      // 会员生日提醒
      if (this.activityType == 15) {
        if (!this.formData.isOneDayBirth && !this.formData.userActDayStart) {
          return this.$message.warning("请输入距离前几天的会员");
        }
        param.userActDayStart = param.userActDayEnd = this.formData
          .isOneDayBirth
          ? 0
          : this.formData.userActDayStart;
      }

      // 会员日营销
      if (this.activityType == 16) {
        if(this.formData.cycleDayMonthly == ''){
          return this.$message.warning("会员发送时间不能为空");
        }
        // 开卡时间不能为空
        let userActDateSelectType = formData.userActDateSelectType;
        if(userActDateSelectType === 0 && (formData.userActDateStart == '' || formData.userActDateEnd == '')){
          // 区间时间
          return this.$message.warning("会员开卡时间不能为空");
        } else if(userActDateSelectType === 2 && formData.userActDateEnd == ''){
          // 小于时间
          return this.$message.warning("会员开卡时间不能为空");
        } else if(userActDateSelectType === 1 && formData.userActDateStart == ''){
          // 大于时间
          return this.$message.warning("会员开卡时间不能为空");
        } else if(userActDateSelectType === 3 && (formData.relativeDayStart == '' || formData.relativeDayEnd == '')){
          // 相对时间
          return this.$message.warning("会员开卡时间不能为空");
        } 

        // 会员积分不能为空
        let memberPointsType = formData.memberPointsType;
        if(memberPointsType === 0 && (formData.userActNumStart == '' || formData.userActNumEnd == '')){
          // 区间时间
          return this.$message.warning("会员积分不能为空");
        } else if(memberPointsType === 2 && formData.userActNumEnd == ''){
          // 小于时间
          return this.$message.warning("会员积分不能为空");
        } else if(memberPointsType === 1 && formData.userActNumStart == ''){
          // 大于时间
          return this.$message.warning("会员积分不能为空");
        }

        // 哪几天
        param.cycleDayMonthly = formData.cycleDayMonthly;
        // 几点
        param.sendTime = formData.sendTime;
        // 开卡时间
        param.userActDateSelectType = formData.userActDateSelectType;
        param.userActDateStart = formData.userActDateStart;
        param.userActDateEnd = formData.userActDateEnd;
        // 相对时间
        param.userActDayStart = formData.relativeDayStart;
        param.userActDayEnd = formData.relativeDayEnd;
        // 会员等级
        // 转换为用字符串
        let memberLevelData = formData.memberLevel;
        if(memberLevelData.length > 0){
          param.memberLevel = memberLevelData.join(",");
        }else {
          param.memberLevel = '';
        }
        // 会员积分
        param.userActNumStart = formData.userActNumStart;
        param.userActNumEnd = formData.userActNumEnd;
        // 会员价值
        let userValueData = formData.userValue;
        if(userValueData.length > 0){
          param.userValue = userValueData.join(",");
        }else {
          param.userValue = '';
        }
      }

      // 京享值用户兴趣转化
      if (this.activityType == 17) {
        // 京享值人群不能为空
        let jdGroupType = formData.jdGroupType;
        if(jdGroupType === 0 && (formData.jdGroupMin == '' || formData.jdGroupMax == '')){
          // 区间时间
          return this.$message.warning("京享值人群不能为空");
        } else if(jdGroupType === 2 && formData.jdGroupMax == ''){
          // 小于时间
          return this.$message.warning("京享值人群不能为空");
        } else if(jdGroupType === 1 && formData.jdGroupMin == ''){
          // 大于时间
          return this.$message.warning("京享值人群不能为空");
        }
        // 京享值类型
        // param.jdGroupType = formData.jdGroupType;
        // 京享值
        param.userActNumStart = formData.jdGroupMin;
        param.userActNumEnd = formData.jdGroupMax;
        // 近几天
        // 是否选中
        if(formData.isjdDays){
          param.lastDaysAddCartFollowFlag = 1;
        }else {
          param.lastDaysAddCartFollowFlag = 0;
        }
        param.userActDayStart = formData.isShowDays;
      }

      // 京东plus会员
      if (this.activityType == 18) {
        // plus会员状态
        let plusLevelData = formData.plusLevel;
        param.plusUserStage = plusLevelData.join(",");
        // 京享值
        let memberLevelData = formData.level2;
        param.memberLevel = memberLevelData.join(",");
      }

      // 储值用户提醒
      if (this.activityType == 19) {
        // 充值时间
        param.userActDateStart = formData.reChangeMinTime;
        param.userActDateEnd = formData.reChangeMaxTime;
        // 充值次数
        param.userActNumStart = formData.rechargeFirst;
        param.userActNumEnd = formData.rechargeEnd;
        // 充值金额
        param.userActAmountStart = formData.userActAmountStart;
        param.userActAmountEnd = formData.userActAmountEnd;
        // 储值卡余额
        param.userActAmountStart2 = formData.userActAmountStart2;
        param.userActAmountEnd2 = formData.userActAmountEnd2;
      }

      console.log("param------>", param);
      //兼容如果类型是9的话 不传给后端
      let TypeList = [9, 8, 1, 2, 3];
      console.log(this.activityType, TypeList.indexOf(this.activityType));
      if (TypeList.indexOf(this.activityType) != -1) {
        param.userActDayStart = "";
        param.userActDayEnd = "";
      }

      var content = this.formData.content;
      var jdLink = this.formData.jdShortLink;
      var regex = new RegExp("3.cn", "g");
      var count = content.match(regex);
      // console.log('count', count)

      if (count && count.length > 1) {
        this.$message.warning("官方插入的短链接不允许超过1个哦！");
        return;
      }

      if (content.indexOf(jdLink) == "-1") {
        this.formData.jdShortLink = "";
        this.formData.url = "";
      }

      // if (filterCondition.indexOf("1") != "-1") {
      //   // 是否过滤黑名单
      //   param.filterBlacklistFlag = true;
      // }
      param.filterBlacklistFlag = this.checked1;
      param.filterAlreadySentFlag = this.checked2;
      if (this.checked2) {
        // 是否过滤几天已发送的客户
        // param.filterAlreadySentFlag = true;
        if (formData.filterDays < 1) {
          this.$message.warning("屏蔽已发送客户需填写大于0的正整数");
          return;
        }
        param.filterDays = formData.filterDays;
      }
      if (this.activityType != 1) {
        param.lastBuyAfterDays = formData.lastBuyAfterDays;
      }
      console.log("param------>", param);

      this.createLoading = true;
      createMarketing(param).then((res) => {
        this.createLoading = false;
        if (res.code == "1") {
          this.$message.success("创建成功！");
          var obj = {
            refresh: true,
          };
          this.$emit("onClose", obj);
          // 返回列表重新埋点
          this.buriedPoint(1, "自动化营销模型", "客户营销", "自动化营销(官方)");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleCancel() {
      // 返回列表重新埋点
      this.buriedPoint(1, "自动化营销模型", "客户营销", "自动化营销(官方)");
      this.$emit("onClose");
    },

    // 确认发送弹窗确认按钮
    handleSendConfirm() {
      this.showSendConfirm = false;
      var mobiles = this.mobiles.split(",");
      var dataFrom = 0;
      var sendType = 0;
      var param = {
        dataFrom,
        sendType,
        mobiles,
      };
      // preCommit(param).then((res) => {
      let postData = {
        content: this.formData.content+'拒收请回复R',
        // jdSmsSuffix: this.formData.jdSmsSuffix,
        mobile: param.mobiles.join(','),
      }
      // 短信测试新接口
      NewPreCommit(postData).then((res) => {
        if (res.code == "1") {

          // var preData = {
          //   sendObjectCount: res.data.sendObjectCount,
          //   sendObjectId: res.data.sendObjectId,
          // };
          // var paramX = {
          //   content: this.formData.content + this.TTip,
          //   sendObjectId: res.data.sendObjectId,
          //   smsSuffix: this.formData.jdSmsSuffix,
          //   blackFlag: false,
          //   smsType: 0,
          // };
          // platformSend(paramX).then((res) => {
          //   if (res.code == "1") {
              this.$message.success(res.data);
          //   } else {
          //     this.$message.error(res.message);
          //   }
          // });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 测试短信发送前的弹窗提示
    async handleShowSendTip() {
      var mobiles = this.mobiles;
      if (!/[\S]+/.test(mobiles)) {
        this.$message.warning("手机号不能为空，请输入正确的手机号 !");
        return;
      }
      // 替换逗号(不论中/英文逗号，都替换成英文逗号)
      mobiles = mobiles.replace(/(,|，)/g, ",");
      // 切换成数组
      var mobleList = mobiles.split(",");
      var mobileArr = [];
      for (var i = 0; i < mobleList.length; i++) {
        if (/^1[3456789]\d{9}$/.test(mobleList[i])) {
          mobileArr.push(mobleList[i]);
        }
      }

      var newMobleArr = [];
      for (var i = 0; i < mobileArr.length; i++) {
        if (newMobleArr.indexOf(mobileArr[i]) == -1) {
          newMobleArr.push(mobileArr[i]);
        }
      }
      if (newMobleArr.length <= 0) {
        this.$message.warning("号码无效，请输入有效号码 !");
        return;
      }
      // if (newMobleArr.length > 5) {
      //   this.$message.warning("测试发送最多只能发送5个有效号码 !");
      //   return;
      // }

      // 敏感词检测
      const checkResult = await this.$wordCheck({
        content: this.formData.content,
      });
      if (checkResult.code != 1) {
        return this.$message.error(checkResult.message);
      }

      var content = this.formData.content;
      if (content && content.trim().length > 0) {
        this.mobiles = newMobleArr.join(",");
        // this.strLenght = content.length + this.formData.jdSmsSuffix.length;
        this.phoneLenght = this.mobiles.split(",").length;
        this.showSendConfirm = true;
      } else {
        this.$message.warning("短信内容不能为空哦！");
      }
    },
    transferName() {
      this.smsDialogs = false;
    },
    smsDialogClose(data) {
      this.smsDialogs = data;
    },

    // 短信测试的校验
    phoneTest(val) {
      var reg = /[^\d,，\s]/g,
        mobiles = val;
      if (reg.test(mobiles)) {
        mobiles = mobiles.replace(reg, "");
      }
      this.mobiles = mobiles;
    },

    goSuffixUrl() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
      });
      window.open(routeUrl.href, "_blank");
    },

    // 切换短信签名
    switchSuffix(index) {
      if (this.isCatch) {
        return;
      }
      this.selectSuffix = this.suffixList[index];
      this.formData.jdSmsSuffix = this.selectSuffix || "";
    },
    // 短信模板隐藏
    templateChange(val, item) {
      this.templateShow = false;
      console.log("模版选择返回==", val, item);
      if (val == true) {
        this.selectTemplate = item;
        // this.formData.content = this.formData.content + item.content;
        this.formData.jdShortLink = "";
        this.formData.content = item.content;
      }
    },
    handleShowModule() {
      // 保存模板 显示
      var param = {
        type: 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.dirList = res.data;
          this.keepTmpShow = true;
        }
      });
    },
    // 保存模板隐藏
    keepTmpChange(val) {
      this.keepTmpShow = false;
      // 保存
      if (val == 1) {
        var param = {
          tid: this.keepTmpValue,
          content: this.formData.content,
        };
        createTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("保存模板成功！");
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 获取官方和系统的的短信签名
    getOfficialSuffix() {
      // 1.系统 2.京东官方签
      getPrecisionJdSuffixList(2).then((res) => {
        if (res.code == "1") {
          this.suffixList = res.data;
          this.selectSuffix = this.suffixList[0];
          this.formData.jdSmsSuffix = this.selectSuffix || "";
        }
      });
    },

    moneyPayTimeChange() {},
    clearTime() {
      this.formData.activityStartTime = "";
      this.formData.activityEndTime = "";
    },
    filterCondiions() {
      console.log(this.formData.filterCondition);
    },
    timeChange() {},
    routerLinkOne() {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/share_polite",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 会员日营销
    clearmembershipTime() {
      this.formData.userActDateStart = "";
      this.formData.userActDateEnd = "";
    },
    levelChange(val) {
      if (val.length) {
        if (val[val.length - 1] == "") {
          this.form.level = [""];
        } else {
          this.form.level = val.filter((item) => item != "");
        }
      }
    },
    // 会员积分
    clearmemberPointsTime() {
      this.formData.memberPointsEndTime = "";
      this.formData.memberPointsStartTime = "";
    },
    // 充值时间
    clearReChangeTime() {
      this.formData.reChangeMinTime = "";
      this.formData.reChangeMaxTime = "";
      this.formData.dates = "";
    },
    // 限制大于等于0正数，带两个小数点
    handelInput(dataName) {
      let inputValue = this.formData[`${dataName}`];

      // 除数字和小数点之外
      inputValue = inputValue.replace(/^\d[0,9]\.[0-9]{2}?$/, "");

      // 限制小数点后两位
      const parts = inputValue.split(".");
      if (parts[0].length > 1 && parts[0].charAt(0) == "0") {
        parts[0] = parts[0].substring(1);
      }
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
        inputValue = parts[0] + "." + parts[1];
      } else {
        inputValue = parts[0];
      }

      let value = isNaN(inputValue) ? "" : inputValue.toString();
      // 更新数据
      this.formData[`${dataName}`] = value;
      this.$forceUpdate();
    },
    handleCount(dataName, isZero = false) {
      let inputValue = this.formData[`${dataName}`];
      inputValue = inputValue.replace(/[^0-9]/g, "");
      if (inputValue.length > 1 && inputValue.charAt(0) == "0") {
        inputValue = inputValue.substring(1);
      }
      // 为空赋值为0
      if (isZero) {
        if (inputValue == "") {
          inputValue = 0;
        }
      }
      // 更新数据
      this.formData[`${dataName}`] = inputValue.toString();
      this.$forceUpdate();
    },
    handlePoint() {
      this.formData.userActNumStart = "";
      this.formData.userActNumEnd = "";
    },
    handleJdGroupType(val) {
      this.formData.jdGroupType = val;
      this.formData.jdGroupMin = "";
      this.formData.jdGroupMax = "";
      this.$forceUpdate();
    },
    // 充值次数
    handlerechargeType() {
      this.formData.rechargeFirst = "0";
      if (this.formData.rechargeTimeType == 0) {
        this.formData.rechargeEnd = "10";
      } else {
        this.formData.rechargeEnd = "0";
      }
    },
    // 充值金额
    handlerechargeAmountType() {
      this.formData.userActAmountStart = "0";
      if (this.formData.rechargeAmountType == 0) {
        this.formData.userActAmountEnd = "1000";
      } else {
        this.formData.userActAmountEnd = "0";
      }
    },
    // 储值卡余额
    handlereCardType() {
      this.formData.userActAmountStart2 = "0";
      if (this.formData.cardType == 0) {
        this.formData.userActAmountEnd2 = "10000";
      } else {
        this.formData.userActAmountEnd2 = "0";
      }
    },
    handleMembershipOpeningTimeType() {
      this.formData.userActDateStart = "";
      this.formData.userActDateEnd = "";
      this.formData.relativeDayStart = "";
      this.formData.relativeDayEnd = "";
    },
    // 限制只能输入1-90
    handleInputByNinety(dataName) {
      let inputValue = this.formData[`${dataName}`];
      inputValue = inputValue.replace(/[^0-9]/g, "");
      if (inputValue.length > 1 && inputValue.charAt(0) == "0") {
        inputValue = inputValue.substring(1);
      }
      if (Number(inputValue) <= 1) {
        inputValue = 1;
      }
      if (Number(inputValue) >= 90) {
        inputValue = 90;
      }
      // 更新数据
      this.formData[`${dataName}`] = inputValue.toString();
      this.$forceUpdate();
    },
    // 获取一年前
    getOneYearAgo() {
      const today = new Date();
      const oneYearAgo = new Date(today);
      var seperator1 = '-';
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
      var year = oneYearAgo.getFullYear();
      var month = oneYearAgo.getMonth() + 1;
      var strDate = oneYearAgo.getDate();
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      return year + seperator1 + month + seperator1 + strDate;
    },
    // 获取当天
    getNewDay(){
      const today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth() + 1;
      var strDate = today.getDate();
      var seperator1 = '-';
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      return year + seperator1 + month + seperator1 + strDate;
    },
    // 选择器监听
    changeDays(val) {
      let arr = val.join(",");
      this.formData.cycleDayMonthly = arr;
    },
    toDingGou() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch"
      );
    },
    changeCheck(val){
      console.log("val", val);
      this.formData.isjdDays = val;
      if(val) {
        this.formData.isShowDays = "1";
      }else {
        this.formData.isShowDays = "";
      }
      
      this.$forceUpdate();
    },
    handlechackBox(){
      this.$forceUpdate();
      console.log("formData.memberLevel", this.formData.memberLevel);
    },
    // copyArr(arr) {
    //   let res = []
    //   for (let i = 0; i < arr.length; i++) {
    //     res.push(arr[i])
    //   }
    //   return res
    // }
  },
};
</script>

<style lang="scss" scoped>
.el-radio__input.is-checked + .el-radio__label {
  color: #409eff !important;
}

.select-goods-tips {
  color: #fe4d45;

  .toLink {
    cursor: pointer;
    color: #7f85e9;
  }
}

.bb {
  .el-radio:nth-last-of-type(1) {
    margin-right: 0;
  }

  .sku_button {
    width: 188px;
    height: 32px;
    padding: 0 12px;
    border-radius: 3px;
    border: 1px solid #7f85e9;
    color: #7f85e9;
    background-color: #f7f8fe;
    cursor: pointer;
    &:hover {
      color: #7f85e9;
      background-color: #f2f3fd;
    }
    &:active {
      color: #7f85e9;
      background-color: #ecedfc;
    }
  }
}

.table {
  max-height: 400px;
  overflow: auto;
  width: 150%;

  .goods_box {
    display: flex;
    align-items: center;

    .img {
      width: 60px;
      height: 60px;
      margin-right: 20px;
      border-radius: 6px;
    }

    .content {
      width: 100%;

      .title {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }
    }
  }

  .cycleInput {
    width: 60px;
    display: inline-block;
  }
  .edit_btn {
    color: #7f85e9;
    font-size: 14px;
    padding: 0px !important;
    border: 0px;
    height: 20px;
    line-height: 20px;
    width: auto;

    margin-right: 10px;
  }
  .del_btn {
    width: auto;
    font-size: 14px;
    padding: 0px !important;
    border: 0px;
    height: 20px;
    line-height: 20px;
    color: #fe4d45;
    margin-left: 0px;
    margin-right: 10px;
  }
}

.search {
  color: rgb(254, 77, 69);
  background-color: #ffffff;
  border-radius: 3px;
  border: 1px solid rgb(254, 77, 69);
  font-size: 14px;

  &.is-disabled {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
  }
}

.search:hover {
  color: #ffffff;
  background-color: rgb(254, 77, 69);

  &.is-disabled {
    background-color: #f5f7fa;
    border-color: #e4e7ed !important;
    color: #c0c4cc;
  }
}

.send-tip {
  position: absolute;
  width: 450px;
  color: #fe4d45;
  padding-left: 10px;
}

/deep/ .day-padding input {
  padding-left: 30px !important;
}

.tip-box-global {
  position: relative;
}

/* 发送确认弹窗 */
.send-con-dialog {
  .success-tip {
    text-align: center;
    font-size: 14px;
    color: #333;

    img {
      margin-right: 10px;
      vertical-align: middle;
    }
  }

  .btn-group {
    margin-top: 30px;
    text-align: center;
  }
}

.test {
  font-size: 14px;

  // height: 32px;
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    width: 98px;
    height: 32px;
    cursor: pointer;
  }

  .ipt {
    width: 224px;
    margin: 0 0px 0 8px;
    vertical-align: top;
  }

  .sendTest {
    // color: #FE4D45;
    width: 106px;
    margin-left: 16px;
    color: #fe4d45;
    border-radius: 3px;
    font-size: 14px;
    padding: 5px 12px;
    border: 1px solid #fe4d45;
    background-color: #fff;

    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }

    &:active {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }

  .record {
    margin: 0 0px 0 8px;
    color: #333333;
    font-size: 14px;
    border-radius: 3px;
    border: 1px solid #cccccc;
    background-color: #fff;

    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}

.box-shadow {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
}

.task-official-box {
  padding: 11px 20px;

  .task-content {
    padding: 20px 27px;
  }

  .nav-box {
    height: 54px;
    line-height: 54px;
    border-bottom: 1px solid #f0f0f0;
    padding-left: 27px;

    .go-back {
      font-size: 14px;
      color: #999999;
      vertical-align: middle;
      cursor: pointer;
    }

    .division {
      display: inline-block;
      vertical-align: middle;
      margin: 0 20px;
      width: 1px;
      height: 20px;
      background: #cccccc;
    }

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #2e3458;
      vertical-align: middle;
      margin-right: 60px;
    }
  }

  .step1-box {
    font-size: 14px;
    color: #333;
    width: 1666px;
    position: relative;

    &::after {
      display: block;
      content: "";
      width: 1px;
      height: 370px;
      background: #dddddd;
      position: absolute;
      top: 27px;
      left: 11px;
    }
  }

  .step1-box-long {
    font-size: 14px;
    color: #333;
    width: 1666px;
    position: relative;

    &::after {
      display: block;
      content: "";
      width: 1px;
      height: 600px;
      background: #dddddd;
      position: absolute;
      top: 27px;
      left: 11px;
    }
  }

  .step2-box {
    position: relative;
    min-height: 600px;

    .step2FormSearch {
      margin-left: 90px;
      width: 700px;
      display: inline-block;

      @media screen and (max-width: 1370px) {
        width: 700px;
        margin-left: 30px;
      }
    }

    &::after {
      display: block;
      content: "";
      width: 1px;
      height: 580px;
      background: #dddddd;
      position: absolute;
      top: 27px;
      left: 11px;
    }
  }
}

.btnList {
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    cursor: pointer;
  }

  .btnBox {
    display: inline-block;
    position: relative;
    overflow: hidden;
    height: 32px;
    margin-right: 20px;

    .btn {
      width: 114px;
      height: 32px;
      color: #999999;
      border: 1px solid #cccccc;
      padding-left: 15px;
      border-radius: 3px;
      padding-right: 15px;

      cursor: pointer;
    }

    .check {
      position: absolute;
      right: -16px;
      bottom: -16px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }

    i {
      position: absolute;
      right: 16px;
      bottom: 15px;
      font-size: 10px;
      color: #fff;
    }
  }
}

/** 步骤条 */
.step-bar {
  background: #fafafa;
  position: relative;
  padding-left: 12px;
  margin-left: 29px;
  margin-bottom: 20px;
  width: -webkit-calc(100% - 80px);
  width: -moz-calc(100% - 80px);
  width: calc(100% - 80px);

  .serial {
    width: 22px;
    height: 22px;
    border-radius: 22px;
    color: #fff;
    line-height: 22px;
    text-align: center;
    display: inline-block;
    line-height: 22px;
    position: absolute;
    left: -29px;
    top: 50%;
    transform: translateY(-50%);
  }

  .division {
    display: inline-block;
    width: 3px;
    height: 14px;
    margin-right: 8px;
    vertical-align: middle;
  }

  .name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    line-height: 32px;
    vertical-align: middle;
  }
}

.textarea {
  box-sizing: border-box;
  padding: 6px 6px 10px;
  width: 100%;
  background: rgba(249, 250, 251, 1);
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 2px;

  .footInfo {
    display: flex;
    justify-content: space-between;
    margin-top: 9px;
    font-size: 14px;
    color: #333;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 76px;
      height: 28px;
      outline: none;
      border: none;
      background-color: white;
      border-radius: 2px;
      font-size: 13px;
    }

    div {
      display: flex;
      align-items: center;
    }

    .select {
      cursor: pointer;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      border-radius: 3px;
      background-color: #fff4f4;

      &:hover {
        color: #fe4d45;
        background-color: #ffe5e5;
      }

      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }

    .keep {
      margin: 0 10px 0 8px;
      cursor: pointer;
      color: #ffffff;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;

      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }

      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
}

.footTips {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding-left: 12px;
  height: 28px;
  background: rgba(255, 250, 238, 1);
  border: 1px solid rgba(255, 185, 94, 1);
  border-radius: 2px;
  color: #333;
  font-size: 13px;
}

.question_icon {
  width: 14px;
  height: 14px;
  color: #7f85e9 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #7f85e9;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;
}

.ask_content {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-right: 2px;
  cursor: pointer;

  .askContentBox {
    font-weight: normal;
    margin-left: 12px;
    color: #7f85e9;

    @media screen and (max-width: 1370px) {
      width: 60px;
    }
  }

  .ask-icon {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
  }

  .ask-icon-select {
    position: absolute;
    bottom: 38px;
    margin-left: -133px;
    display: none !important;
    width: 375px;
    // height: 80px;
    line-height: 20px;
    padding: 20px;
    background-color: #fff;
    text-align: left;
    box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
    color: #999999;
    z-index: 1;
  }

  .ask-icon-select:before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    right: 50%;
    margin-left: -4px;
    top: 100%;
    border-left: 8px solid transparent;
    border-top: 8px solid #fff;
    border-right: 8px solid transparent;
  }
}

.ask_content:hover {
  .ask-icon-select {
    display: block !important;
  }
}

.selectBox {
  text-align: right;

  .headCnt {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }

  .keepBtn {
    width: 98px;
    height: 32px;
    line-height: 30px;
    margin-top: 20px;
    text-align: center;
    background: rgba(254, 77, 69, 1);
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
  }

  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
  }
}

.mobile-box {
  position: relative;
  width: 256px;
  margin-top: 21px;
  height: 504px;

  @media screen and (max-width: 1450px) {
    margin-left: -140px;
  }

  @media screen and (max-width: 1370px) {
    margin-left: -234px;
  }

  // background: url("../../assets/images/mobileScreen.png") no-repeat;
  .message-content {
    position: absolute;
    word-wrap: break-word;
    max-height: 250px;
    overflow-y: auto;
    padding: 12px 12px;
    border-radius: 6px;
    width: 210px;
    font-size: 14px;
    background-color: #fafafa;
    line-height: 20px;
    left: 50%;
    margin-left: -104.665px;
    text-align: left;
    top: 25.4%;
  }
}

.mobile-tips {
  margin-top: 12px;
  font-size: 16px;
  text-align: center;
  color: rgba(51, 51, 51, 1);
}

.xiao_hug2 {
  position: absolute;
  top: 50px;
  left: 990px;
}

.foot {
  border-top: 1px solid #f6f6f6;
  margin-top: 140px;
  text-align: center;
  padding: 20px 0;
  // padding-left: 165px;
  // margin-bottom: 30px;
  margin-left: -25px;
  margin-right: -25px;
}

.explain {
  display: inline-block;
  width: 14px;
  height: 14px;
  padding: 3px;
  text-align: center;
  line-height: 6px;
  border-radius: 50%;
  color: #ccc;
  font-size: 12px;
  margin-left: 8px;
  border: 1px solid #ccc;
  cursor: default;
}

.tool {
  display: flex;
  align-items: center;

  p {
    box-sizing: border-box;
    padding: 0 8px;
    margin: 0 8px 0 0;
    font-size: 14px;
    border-radius: 3px;
    background-color: #f7f8fe;
    border: 1px solid #7f85e9;
    color: #7f85e9;

    &:hover {
      background: rgba(174, 179, 241, 0.16);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9 !important;
    }

    &:active {
      background: rgba(174, 179, 241, 0.24);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9;
    }
  }
}

.tip-text {
  margin-left: 20px;
  color: #7f7f7f;
  font-size: 14px;
  position: absolute;
  width: 200px;
}

.checked-box {
  display: inline-block;
  vertical-align: middle;
}

.span-text {
  display: inline-block;
  width: 85px;
  text-align: right;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
  .cancel,
  .confirm {
    width: 98px;
    font-size: 14px;
    height: 32px;
  }
  .cancel {
    margin-right: 8px;
    color: #999999;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .confirm {
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
}
</style>
<style lang="scss">
.test-popper .el-select-dropdown__list {
  display: flex;
  width: 230px;
  flex-wrap: wrap;

  .el-select-dropdown__item {
    width: 29px;
    height: 28px;
    line-height: 28px;
    padding: 0;
    text-align: center;
    margin: 3px;
  }
  .el-select-dropdown__item.selected::after {
    display: none;
  }
  .el-select-dropdown__item.selected {
    background-color: #fe4d45 !important;
    color: #fff;
    border-radius: 25px;
    font-weight: normal;
  }
}
.jdDays {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #333;
  }
}
</style>